window.jQuery ||
    (function (e, t) {
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = e.document
                  ? t(e, !0)
                  : function (e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e);
                    })
            : t(e);
    })("undefined" != typeof window ? window : this, function (e, t) {
        var n = [],
            i = n.slice,
            o = n.concat,
            r = n.push,
            a = n.indexOf,
            s = {},
            l = s.toString,
            c = s.hasOwnProperty,
            u = "".trim,
            d = {},
            p = "1.11.0",
            f = function (e, t) {
                return new f.fn.init(e, t);
            },
            h = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
            m = /^-ms-/,
            g = /-([\da-z])/gi,
            y = function (e, t) {
                return t.toUpperCase();
            };
        function v(e) {
            var t = e.length,
                n = f.type(e);
            return "function" !== n && !f.isWindow(e) && (!(1 !== e.nodeType || !t) || "array" === n || 0 === t || ("number" == typeof t && t > 0 && t - 1 in e));
        }
        (f.fn = f.prototype = {
            jquery: p,
            constructor: f,
            selector: "",
            length: 0,
            toArray: function () {
                return i.call(this);
            },
            get: function (e) {
                return null != e ? (0 > e ? this[e + this.length] : this[e]) : i.call(this);
            },
            pushStack: function (e) {
                var t = f.merge(this.constructor(), e);
                return (t.prevObject = this), (t.context = this.context), t;
            },
            each: function (e, t) {
                return f.each(this, e, t);
            },
            map: function (e) {
                return this.pushStack(
                    f.map(this, function (t, n) {
                        return e.call(t, n, t);
                    })
                );
            },
            slice: function () {
                return this.pushStack(i.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            eq: function (e) {
                var t = this.length,
                    n = +e + (0 > e ? t : 0);
                return this.pushStack(n >= 0 && t > n ? [this[n]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor(null);
            },
            push: r,
            sort: n.sort,
            splice: n.splice,
        }),
            (f.extend = f.fn.extend = function () {
                var e,
                    t,
                    n,
                    i,
                    o,
                    r,
                    a = arguments[0] || {},
                    s = 1,
                    l = arguments.length,
                    c = !1;
                for ("boolean" == typeof a && ((c = a), (a = arguments[s] || {}), s++), "object" == typeof a || f.isFunction(a) || (a = {}), s === l && ((a = this), s--); l > s; s++)
                    if (null != (o = arguments[s]))
                        for (i in o)
                            (e = a[i]),
                                a !== (n = o[i]) &&
                                    (c && n && (f.isPlainObject(n) || (t = f.isArray(n)))
                                        ? (t ? ((t = !1), (r = e && f.isArray(e) ? e : [])) : (r = e && f.isPlainObject(e) ? e : {}), (a[i] = f.extend(c, r, n)))
                                        : void 0 !== n && (a[i] = n));
                return a;
            }),
            f.extend({
                expando: "jQuery" + (p + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                    throw new Error(e);
                },
                noop: function () {},
                isFunction: function (e) {
                    return "function" === f.type(e);
                },
                isArray:
                    Array.isArray ||
                    function (e) {
                        return "array" === f.type(e);
                    },
                isWindow: function (e) {
                    return null != e && e == e.window;
                },
                isNumeric: function (e) {
                    return e - parseFloat(e) >= 0;
                },
                isEmptyObject: function (e) {
                    var t;
                    for (t in e) return !1;
                    return !0;
                },
                isPlainObject: function (e) {
                    var t;
                    if (!e || "object" !== f.type(e) || e.nodeType || f.isWindow(e)) return !1;
                    try {
                        if (e.constructor && !c.call(e, "constructor") && !c.call(e.constructor.prototype, "isPrototypeOf")) return !1;
                    } catch (e) {
                        return !1;
                    }
                    if (d.ownLast) for (t in e) return c.call(e, t);
                    for (t in e);
                    return void 0 === t || c.call(e, t);
                },
                type: function (e) {
                    return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? s[l.call(e)] || "object" : typeof e;
                },
                globalEval: function (t) {
                    t &&
                        f.trim(t) &&
                        (
                            e.execScript ||
                            function (t) {
                                e.eval.call(e, t);
                            }
                        )(t);
                },
                camelCase: function (e) {
                    return e.replace(m, "ms-").replace(g, y);
                },
                nodeName: function (e, t) {
                    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                },
                each: function (e, t, n) {
                    var i = 0,
                        o = e.length,
                        r = v(e);
                    if (n) {
                        if (r) for (; o > i && !1 !== t.apply(e[i], n); i++);
                        else for (i in e) if (!1 === t.apply(e[i], n)) break;
                    } else if (r) for (; o > i && !1 !== t.call(e[i], i, e[i]); i++);
                    else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                    return e;
                },
                trim:
                    u && !u.call("\ufeffÃ‚ ")
                        ? function (e) {
                              return null == e ? "" : u.call(e);
                          }
                        : function (e) {
                              return null == e ? "" : (e + "").replace(h, "");
                          },
                makeArray: function (e, t) {
                    var n = t || [];
                    return null != e && (v(Object(e)) ? f.merge(n, "string" == typeof e ? [e] : e) : r.call(n, e)), n;
                },
                inArray: function (e, t, n) {
                    var i;
                    if (t) {
                        if (a) return a.call(t, e, n);
                        for (i = t.length, n = n ? (0 > n ? Math.max(0, i + n) : n) : 0; i > n; n++) if (n in t && t[n] === e) return n;
                    }
                    return -1;
                },
                merge: function (e, t) {
                    for (var n = +t.length, i = 0, o = e.length; n > i; ) e[o++] = t[i++];
                    if (n != n) for (; void 0 !== t[i]; ) e[o++] = t[i++];
                    return (e.length = o), e;
                },
                grep: function (e, t, n) {
                    for (var i = [], o = 0, r = e.length, a = !n; r > o; o++) !t(e[o], o) !== a && i.push(e[o]);
                    return i;
                },
                map: function (e, t, n) {
                    var i,
                        r = 0,
                        a = e.length,
                        s = [];
                    if (v(e)) for (; a > r; r++) null != (i = t(e[r], r, n)) && s.push(i);
                    else for (r in e) null != (i = t(e[r], r, n)) && s.push(i);
                    return o.apply([], s);
                },
                guid: 1,
                proxy: function (e, t) {
                    var n, o, r;
                    return (
                        "string" == typeof t && ((r = e[t]), (t = e), (e = r)),
                        f.isFunction(e)
                            ? ((n = i.call(arguments, 2)),
                              ((o = function () {
                                  return e.apply(t || this, n.concat(i.call(arguments)));
                              }).guid = e.guid = e.guid || f.guid++),
                              o)
                            : void 0
                    );
                },
                now: function () {
                    return +new Date();
                },
                support: d,
            }),
            f.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
                s["[object " + t + "]"] = t.toLowerCase();
            });
        var b = (function (e) {
            var t,
                n,
                i,
                o,
                r,
                a,
                s,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                g,
                y,
                v = "sizzle" + -new Date(),
                b = e.document,
                x = 0,
                w = 0,
                T = ie(),
                C = ie(),
                k = ie(),
                N = function (e, t) {
                    return e === t && (c = !0), 0;
                },
                E = "undefined",
                _ = 1 << 31,
                S = {}.hasOwnProperty,
                j = [],
                z = j.pop,
                A = j.push,
                D = j.push,
                $ = j.slice,
                L =
                    j.indexOf ||
                    function (e) {
                        for (var t = 0, n = this.length; n > t; t++) if (this[t] === e) return t;
                        return -1;
                    },
                W = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                H = "[\\x20\\t\\r\\n\\f]",
                P = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
                q = P.replace("w", "w#"),
                F = "\\[" + H + "*(" + P + ")" + H + "*(?:([*^$|!~]?=)" + H + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + q + ")|)|)" + H + "*\\]",
                O = ":(" + P + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + F.replace(3, 8) + ")*)|.*)\\)|)",
                M = new RegExp("^" + H + "+|((?:^|[^\\\\])(?:\\\\.)*)" + H + "+$", "g"),
                B = new RegExp("^" + H + "*," + H + "*"),
                R = new RegExp("^" + H + "*([>+~]|" + H + ")" + H + "*"),
                Z = new RegExp("=" + H + "*([^\\]'\"]*?)" + H + "*\\]", "g"),
                I = new RegExp(O),
                X = new RegExp("^" + q + "$"),
                G = {
                    ID: new RegExp("^#(" + P + ")"),
                    CLASS: new RegExp("^\\.(" + P + ")"),
                    TAG: new RegExp("^(" + P.replace("w", "w*") + ")"),
                    ATTR: new RegExp("^" + F),
                    PSEUDO: new RegExp("^" + O),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + H + "*(even|odd|(([+-]|)(\\d*)n|)" + H + "*(?:([+-]|)" + H + "*(\\d+)|))" + H + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + W + ")$", "i"),
                    needsContext: new RegExp("^" + H + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + H + "*((?:-\\d)?\\d*)" + H + "*\\)|)(?=[^-]|$)", "i"),
                },
                U = /^(?:input|select|textarea|button)$/i,
                V = /^h\d$/i,
                J = /^[^{]+\{\s*\[native \w/,
                Y = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                Q = /[+~]/,
                K = /'|\\/g,
                ee = new RegExp("\\\\([\\da-f]{1,6}" + H + "?|(" + H + ")|.)", "ig"),
                te = function (e, t, n) {
                    var i = "0x" + t - 65536;
                    return i != i || n ? t : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
                };
            try {
                D.apply((j = $.call(b.childNodes)), b.childNodes), j[b.childNodes.length].nodeType;
            } catch (e) {
                D = {
                    apply: j.length
                        ? function (e, t) {
                              A.apply(e, $.call(t));
                          }
                        : function (e, t) {
                              for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                              e.length = n - 1;
                          },
                };
            }
            function ne(e, t, i, o) {
                var r, a, s, l, c, p, m, g, x, w;
                if (((t ? t.ownerDocument || t : b) !== d && u(t), (i = i || []), !e || "string" != typeof e)) return i;
                if (1 !== (l = (t = t || d).nodeType) && 9 !== l) return [];
                if (f && !o) {
                    if ((r = Y.exec(e)))
                        if ((s = r[1])) {
                            if (9 === l) {
                                if (!(a = t.getElementById(s)) || !a.parentNode) return i;
                                if (a.id === s) return i.push(a), i;
                            } else if (t.ownerDocument && (a = t.ownerDocument.getElementById(s)) && y(t, a) && a.id === s) return i.push(a), i;
                        } else {
                            if (r[2]) return D.apply(i, t.getElementsByTagName(e)), i;
                            if ((s = r[3]) && n.getElementsByClassName && t.getElementsByClassName) return D.apply(i, t.getElementsByClassName(s)), i;
                        }
                    if (n.qsa && (!h || !h.test(e))) {
                        if (((g = m = v), (x = t), (w = 9 === l && e), 1 === l && "object" !== t.nodeName.toLowerCase())) {
                            for (p = fe(e), (m = t.getAttribute("id")) ? (g = m.replace(K, "\\$&")) : t.setAttribute("id", g), g = "[id='" + g + "'] ", c = p.length; c--; ) p[c] = g + he(p[c]);
                            (x = (Q.test(e) && de(t.parentNode)) || t), (w = p.join(","));
                        }
                        if (w)
                            try {
                                return D.apply(i, x.querySelectorAll(w)), i;
                            } catch (e) {
                            } finally {
                                m || t.removeAttribute("id");
                            }
                    }
                }
                return we(e.replace(M, "$1"), t, i, o);
            }
            function ie() {
                var e = [];
                return function t(n, o) {
                    return e.push(n + " ") > i.cacheLength && delete t[e.shift()], (t[n + " "] = o);
                };
            }
            function oe(e) {
                return (e[v] = !0), e;
            }
            function re(e) {
                var t = d.createElement("div");
                try {
                    return !!e(t);
                } catch (e) {
                    return !1;
                } finally {
                    t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
            }
            function ae(e, t) {
                for (var n = e.split("|"), o = e.length; o--; ) i.attrHandle[n[o]] = t;
            }
            function se(e, t) {
                var n = t && e,
                    i = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || _) - (~e.sourceIndex || _);
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                return e ? 1 : -1;
            }
            function le(e) {
                return function (t) {
                    return "input" === t.nodeName.toLowerCase() && t.type === e;
                };
            }
            function ce(e) {
                return function (t) {
                    var n = t.nodeName.toLowerCase();
                    return ("input" === n || "button" === n) && t.type === e;
                };
            }
            function ue(e) {
                return oe(function (t) {
                    return (
                        (t = +t),
                        oe(function (n, i) {
                            for (var o, r = e([], n.length, t), a = r.length; a--; ) n[(o = r[a])] && (n[o] = !(i[o] = n[o]));
                        })
                    );
                });
            }
            function de(e) {
                return e && typeof e.getElementsByTagName !== E && e;
            }
            for (t in ((n = ne.support = {}),
            (r = ne.isXML = function (e) {
                var t = e && (e.ownerDocument || e).documentElement;
                return !!t && "HTML" !== t.nodeName;
            }),
            (u = ne.setDocument = function (e) {
                var t,
                    o = e ? e.ownerDocument || e : b,
                    a = o.defaultView;
                return o !== d && 9 === o.nodeType && o.documentElement
                    ? ((d = o),
                      (p = o.documentElement),
                      (f = !r(o)),
                      a &&
                          a !== a.top &&
                          (a.addEventListener
                              ? a.addEventListener(
                                    "unload",
                                    function () {
                                        u();
                                    },
                                    !1
                                )
                              : a.attachEvent &&
                                a.attachEvent("onunload", function () {
                                    u();
                                })),
                      (n.attributes = re(function (e) {
                          return (e.className = "i"), !e.getAttribute("className");
                      })),
                      (n.getElementsByTagName = re(function (e) {
                          return e.appendChild(o.createComment("")), !e.getElementsByTagName("*").length;
                      })),
                      (n.getElementsByClassName =
                          J.test(o.getElementsByClassName) &&
                          re(function (e) {
                              return (e.innerHTML = "<div class='a'></div><div class='a i'></div>"), (e.firstChild.className = "i"), 2 === e.getElementsByClassName("i").length;
                          })),
                      (n.getById = re(function (e) {
                          return (p.appendChild(e).id = v), !o.getElementsByName || !o.getElementsByName(v).length;
                      })),
                      n.getById
                          ? ((i.find.ID = function (e, t) {
                                if (typeof t.getElementById !== E && f) {
                                    var n = t.getElementById(e);
                                    return n && n.parentNode ? [n] : [];
                                }
                            }),
                            (i.filter.ID = function (e) {
                                var t = e.replace(ee, te);
                                return function (e) {
                                    return e.getAttribute("id") === t;
                                };
                            }))
                          : (delete i.find.ID,
                            (i.filter.ID = function (e) {
                                var t = e.replace(ee, te);
                                return function (e) {
                                    var n = typeof e.getAttributeNode !== E && e.getAttributeNode("id");
                                    return n && n.value === t;
                                };
                            })),
                      (i.find.TAG = n.getElementsByTagName
                          ? function (e, t) {
                                return typeof t.getElementsByTagName !== E ? t.getElementsByTagName(e) : void 0;
                            }
                          : function (e, t) {
                                var n,
                                    i = [],
                                    o = 0,
                                    r = t.getElementsByTagName(e);
                                if ("*" === e) {
                                    for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                                    return i;
                                }
                                return r;
                            }),
                      (i.find.CLASS =
                          n.getElementsByClassName &&
                          function (e, t) {
                              return typeof t.getElementsByClassName !== E && f ? t.getElementsByClassName(e) : void 0;
                          }),
                      (m = []),
                      (h = []),
                      (n.qsa = J.test(o.querySelectorAll)) &&
                          (re(function (e) {
                              (e.innerHTML = "<select t=''><option selected=''></option></select>"),
                                  e.querySelectorAll("[t^='']").length && h.push("[*^$]=" + H + "*(?:''|\"\")"),
                                  e.querySelectorAll("[selected]").length || h.push("\\[" + H + "*(?:value|" + W + ")"),
                                  e.querySelectorAll(":checked").length || h.push(":checked");
                          }),
                          re(function (e) {
                              var t = o.createElement("input");
                              t.setAttribute("type", "hidden"),
                                  e.appendChild(t).setAttribute("name", "D"),
                                  e.querySelectorAll("[name=d]").length && h.push("name" + H + "*[*^$|!~]?="),
                                  e.querySelectorAll(":enabled").length || h.push(":enabled", ":disabled"),
                                  e.querySelectorAll("*,:x"),
                                  h.push(",.*:");
                          })),
                      (n.matchesSelector = J.test((g = p.webkitMatchesSelector || p.mozMatchesSelector || p.oMatchesSelector || p.msMatchesSelector))) &&
                          re(function (e) {
                              (n.disconnectedMatch = g.call(e, "div")), g.call(e, "[s!='']:x"), m.push("!=", O);
                          }),
                      (h = h.length && new RegExp(h.join("|"))),
                      (m = m.length && new RegExp(m.join("|"))),
                      (t = J.test(p.compareDocumentPosition)),
                      (y =
                          t || J.test(p.contains)
                              ? function (e, t) {
                                    var n = 9 === e.nodeType ? e.documentElement : e,
                                        i = t && t.parentNode;
                                    return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                                }
                              : function (e, t) {
                                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                    return !1;
                                }),
                      (N = t
                          ? function (e, t) {
                                if (e === t) return (c = !0), 0;
                                var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                                return (
                                    i ||
                                    (1 & (i = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!n.sortDetached && t.compareDocumentPosition(e) === i)
                                        ? e === o || (e.ownerDocument === b && y(b, e))
                                            ? -1
                                            : t === o || (t.ownerDocument === b && y(b, t))
                                            ? 1
                                            : l
                                            ? L.call(l, e) - L.call(l, t)
                                            : 0
                                        : 4 & i
                                        ? -1
                                        : 1)
                                );
                            }
                          : function (e, t) {
                                if (e === t) return (c = !0), 0;
                                var n,
                                    i = 0,
                                    r = e.parentNode,
                                    a = t.parentNode,
                                    s = [e],
                                    u = [t];
                                if (!r || !a) return e === o ? -1 : t === o ? 1 : r ? -1 : a ? 1 : l ? L.call(l, e) - L.call(l, t) : 0;
                                if (r === a) return se(e, t);
                                for (n = e; (n = n.parentNode); ) s.unshift(n);
                                for (n = t; (n = n.parentNode); ) u.unshift(n);
                                for (; s[i] === u[i]; ) i++;
                                return i ? se(s[i], u[i]) : s[i] === b ? -1 : u[i] === b ? 1 : 0;
                            }),
                      o)
                    : d;
            }),
            (ne.matches = function (e, t) {
                return ne(e, null, null, t);
            }),
            (ne.matchesSelector = function (e, t) {
                if (((e.ownerDocument || e) !== d && u(e), (t = t.replace(Z, "='$1']")), !(!n.matchesSelector || !f || (m && m.test(t)) || (h && h.test(t)))))
                    try {
                        var i = g.call(e, t);
                        if (i || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                    } catch (e) {}
                return ne(t, d, null, [e]).length > 0;
            }),
            (ne.contains = function (e, t) {
                return (e.ownerDocument || e) !== d && u(e), y(e, t);
            }),
            (ne.attr = function (e, t) {
                (e.ownerDocument || e) !== d && u(e);
                var o = i.attrHandle[t.toLowerCase()],
                    r = o && S.call(i.attrHandle, t.toLowerCase()) ? o(e, t, !f) : void 0;
                return void 0 !== r ? r : n.attributes || !f ? e.getAttribute(t) : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
            }),
            (ne.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
            }),
            (ne.uniqueSort = function (e) {
                var t,
                    i = [],
                    o = 0,
                    r = 0;
                if (((c = !n.detectDuplicates), (l = !n.sortStable && e.slice(0)), e.sort(N), c)) {
                    for (; (t = e[r++]); ) t === e[r] && (o = i.push(r));
                    for (; o--; ) e.splice(i[o], 1);
                }
                return (l = null), e;
            }),
            (o = ne.getText = function (e) {
                var t,
                    n = "",
                    i = 0,
                    r = e.nodeType;
                if (r) {
                    if (1 === r || 9 === r || 11 === r) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
                    } else if (3 === r || 4 === r) return e.nodeValue;
                } else for (; (t = e[i++]); ) n += o(t);
                return n;
            }),
            ((i = ne.selectors = {
                cacheLength: 50,
                createPseudo: oe,
                match: G,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (e) {
                        return (e[1] = e[1].replace(ee, te)), (e[3] = (e[4] || e[5] || "").replace(ee, te)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                    },
                    CHILD: function (e) {
                        return (
                            (e[1] = e[1].toLowerCase()),
                            "nth" === e[1].slice(0, 3) ? (e[3] || ne.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && ne.error(e[0]),
                            e
                        );
                    },
                    PSEUDO: function (e) {
                        var t,
                            n = !e[5] && e[2];
                        return G.CHILD.test(e[0])
                            ? null
                            : (e[3] && void 0 !== e[4] ? (e[2] = e[4]) : n && I.test(n) && (t = fe(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (e) {
                        var t = e.replace(ee, te).toLowerCase();
                        return "*" === e
                            ? function () {
                                  return !0;
                              }
                            : function (e) {
                                  return e.nodeName && e.nodeName.toLowerCase() === t;
                              };
                    },
                    CLASS: function (e) {
                        var t = T[e + " "];
                        return (
                            t ||
                            ((t = new RegExp("(^|" + H + ")" + e + "(" + H + "|$)")) &&
                                T(e, function (e) {
                                    return t.test(("string" == typeof e.className && e.className) || (typeof e.getAttribute !== E && e.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (e, t, n) {
                        return function (i) {
                            var o = ne.attr(i, e);
                            return null == o
                                ? "!=" === t
                                : !t ||
                                      ((o += ""),
                                      "=" === t
                                          ? o === n
                                          : "!=" === t
                                          ? o !== n
                                          : "^=" === t
                                          ? n && 0 === o.indexOf(n)
                                          : "*=" === t
                                          ? n && o.indexOf(n) > -1
                                          : "$=" === t
                                          ? n && o.slice(-n.length) === n
                                          : "~=" === t
                                          ? (" " + o + " ").indexOf(n) > -1
                                          : "|=" === t && (o === n || o.slice(0, n.length + 1) === n + "-"));
                        };
                    },
                    CHILD: function (e, t, n, i, o) {
                        var r = "nth" !== e.slice(0, 3),
                            a = "last" !== e.slice(-4),
                            s = "of-type" === t;
                        return 1 === i && 0 === o
                            ? function (e) {
                                  return !!e.parentNode;
                              }
                            : function (t, n, l) {
                                  var c,
                                      u,
                                      d,
                                      p,
                                      f,
                                      h,
                                      m = r !== a ? "nextSibling" : "previousSibling",
                                      g = t.parentNode,
                                      y = s && t.nodeName.toLowerCase(),
                                      b = !l && !s;
                                  if (g) {
                                      if (r) {
                                          for (; m; ) {
                                              for (d = t; (d = d[m]); ) if (s ? d.nodeName.toLowerCase() === y : 1 === d.nodeType) return !1;
                                              h = m = "only" === e && !h && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((h = [a ? g.firstChild : g.lastChild]), a && b)) {
                                          for (f = (c = (u = g[v] || (g[v] = {}))[e] || [])[0] === x && c[1], p = c[0] === x && c[2], d = f && g.childNodes[f]; (d = (++f && d && d[m]) || (p = f = 0) || h.pop()); )
                                              if (1 === d.nodeType && ++p && d === t) {
                                                  u[e] = [x, f, p];
                                                  break;
                                              }
                                      } else if (b && (c = (t[v] || (t[v] = {}))[e]) && c[0] === x) p = c[1];
                                      else for (; (d = (++f && d && d[m]) || (p = f = 0) || h.pop()) && ((s ? d.nodeName.toLowerCase() !== y : 1 !== d.nodeType) || !++p || (b && ((d[v] || (d[v] = {}))[e] = [x, p]), d !== t)); );
                                      return (p -= o) === i || (p % i == 0 && p / i >= 0);
                                  }
                              };
                    },
                    PSEUDO: function (e, t) {
                        var n,
                            o = i.pseudos[e] || i.setFilters[e.toLowerCase()] || ne.error("unsupported pseudo: " + e);
                        return o[v]
                            ? o(t)
                            : o.length > 1
                            ? ((n = [e, e, "", t]),
                              i.setFilters.hasOwnProperty(e.toLowerCase())
                                  ? oe(function (e, n) {
                                        for (var i, r = o(e, t), a = r.length; a--; ) e[(i = L.call(e, r[a]))] = !(n[i] = r[a]);
                                    })
                                  : function (e) {
                                        return o(e, 0, n);
                                    })
                            : o;
                    },
                },
                pseudos: {
                    not: oe(function (e) {
                        var t = [],
                            n = [],
                            i = a(e.replace(M, "$1"));
                        return i[v]
                            ? oe(function (e, t, n, o) {
                                  for (var r, a = i(e, null, o, []), s = e.length; s--; ) (r = a[s]) && (e[s] = !(t[s] = r));
                              })
                            : function (e, o, r) {
                                  return (t[0] = e), i(t, null, r, n), !n.pop();
                              };
                    }),
                    has: oe(function (e) {
                        return function (t) {
                            return ne(e, t).length > 0;
                        };
                    }),
                    contains: oe(function (e) {
                        return function (t) {
                            return (t.textContent || t.innerText || o(t)).indexOf(e) > -1;
                        };
                    }),
                    lang: oe(function (e) {
                        return (
                            X.test(e || "") || ne.error("unsupported lang: " + e),
                            (e = e.replace(ee, te).toLowerCase()),
                            function (t) {
                                var n;
                                do {
                                    if ((n = f ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                } while ((t = t.parentNode) && 1 === t.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (t) {
                        var n = e.location && e.location.hash;
                        return n && n.slice(1) === t.id;
                    },
                    root: function (e) {
                        return e === p;
                    },
                    focus: function (e) {
                        return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                    },
                    enabled: function (e) {
                        return !1 === e.disabled;
                    },
                    disabled: function (e) {
                        return !0 === e.disabled;
                    },
                    checked: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                    },
                    selected: function (e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                    },
                    empty: function (e) {
                        for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (e) {
                        return !i.pseudos.empty(e);
                    },
                    header: function (e) {
                        return V.test(e.nodeName);
                    },
                    input: function (e) {
                        return U.test(e.nodeName);
                    },
                    button: function (e) {
                        var t = e.nodeName.toLowerCase();
                        return ("input" === t && "button" === e.type) || "button" === t;
                    },
                    text: function (e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                    },
                    first: ue(function () {
                        return [0];
                    }),
                    last: ue(function (e, t) {
                        return [t - 1];
                    }),
                    eq: ue(function (e, t, n) {
                        return [0 > n ? n + t : n];
                    }),
                    even: ue(function (e, t) {
                        for (var n = 0; t > n; n += 2) e.push(n);
                        return e;
                    }),
                    odd: ue(function (e, t) {
                        for (var n = 1; t > n; n += 2) e.push(n);
                        return e;
                    }),
                    lt: ue(function (e, t, n) {
                        for (var i = 0 > n ? n + t : n; --i >= 0; ) e.push(i);
                        return e;
                    }),
                    gt: ue(function (e, t, n) {
                        for (var i = 0 > n ? n + t : n; ++i < t; ) e.push(i);
                        return e;
                    }),
                },
            }).pseudos.nth = i.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                i.pseudos[t] = le(t);
            for (t in { submit: !0, reset: !0 }) i.pseudos[t] = ce(t);
            function pe() {}
            function fe(e, t) {
                var n,
                    o,
                    r,
                    a,
                    s,
                    l,
                    c,
                    u = C[e + " "];
                if (u) return t ? 0 : u.slice(0);
                for (s = e, l = [], c = i.preFilter; s; ) {
                    for (a in ((!n || (o = B.exec(s))) && (o && (s = s.slice(o[0].length) || s), l.push((r = []))),
                    (n = !1),
                    (o = R.exec(s)) && ((n = o.shift()), r.push({ value: n, type: o[0].replace(M, " ") }), (s = s.slice(n.length))),
                    i.filter))
                        !(o = G[a].exec(s)) || (c[a] && !(o = c[a](o))) || ((n = o.shift()), r.push({ value: n, type: a, matches: o }), (s = s.slice(n.length)));
                    if (!n) break;
                }
                return t ? s.length : s ? ne.error(e) : C(e, l).slice(0);
            }
            function he(e) {
                for (var t = 0, n = e.length, i = ""; n > t; t++) i += e[t].value;
                return i;
            }
            function me(e, t, n) {
                var i = t.dir,
                    o = n && "parentNode" === i,
                    r = w++;
                return t.first
                    ? function (t, n, r) {
                          for (; (t = t[i]); ) if (1 === t.nodeType || o) return e(t, n, r);
                      }
                    : function (t, n, a) {
                          var s,
                              l,
                              c = [x, r];
                          if (a) {
                              for (; (t = t[i]); ) if ((1 === t.nodeType || o) && e(t, n, a)) return !0;
                          } else
                              for (; (t = t[i]); )
                                  if (1 === t.nodeType || o) {
                                      if ((s = (l = t[v] || (t[v] = {}))[i]) && s[0] === x && s[1] === r) return (c[2] = s[2]);
                                      if (((l[i] = c), (c[2] = e(t, n, a)))) return !0;
                                  }
                      };
            }
            function ge(e) {
                return e.length > 1
                    ? function (t, n, i) {
                          for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                          return !0;
                      }
                    : e[0];
            }
            function ye(e, t, n, i, o) {
                for (var r, a = [], s = 0, l = e.length, c = null != t; l > s; s++) (r = e[s]) && (!n || n(r, i, o)) && (a.push(r), c && t.push(s));
                return a;
            }
            function ve(e, t, n, i, o, r) {
                return (
                    i && !i[v] && (i = ve(i)),
                    o && !o[v] && (o = ve(o, r)),
                    oe(function (r, a, s, l) {
                        var c,
                            u,
                            d,
                            p = [],
                            f = [],
                            h = a.length,
                            m =
                                r ||
                                (function (e, t, n) {
                                    for (var i = 0, o = t.length; o > i; i++) ne(e, t[i], n);
                                    return n;
                                })(t || "*", s.nodeType ? [s] : s, []),
                            g = !e || (!r && t) ? m : ye(m, p, e, s, l),
                            y = n ? (o || (r ? e : h || i) ? [] : a) : g;
                        if ((n && n(g, y, s, l), i)) for (c = ye(y, f), i(c, [], s, l), u = c.length; u--; ) (d = c[u]) && (y[f[u]] = !(g[f[u]] = d));
                        if (r) {
                            if (o || e) {
                                if (o) {
                                    for (c = [], u = y.length; u--; ) (d = y[u]) && c.push((g[u] = d));
                                    o(null, (y = []), c, l);
                                }
                                for (u = y.length; u--; ) (d = y[u]) && (c = o ? L.call(r, d) : p[u]) > -1 && (r[c] = !(a[c] = d));
                            }
                        } else (y = ye(y === a ? y.splice(h, y.length) : y)), o ? o(null, a, y, l) : D.apply(a, y);
                    })
                );
            }
            function be(e) {
                for (
                    var t,
                        n,
                        o,
                        r = e.length,
                        a = i.relative[e[0].type],
                        l = a || i.relative[" "],
                        c = a ? 1 : 0,
                        u = me(
                            function (e) {
                                return e === t;
                            },
                            l,
                            !0
                        ),
                        d = me(
                            function (e) {
                                return L.call(t, e) > -1;
                            },
                            l,
                            !0
                        ),
                        p = [
                            function (e, n, i) {
                                return (!a && (i || n !== s)) || ((t = n).nodeType ? u(e, n, i) : d(e, n, i));
                            },
                        ];
                    r > c;
                    c++
                )
                    if ((n = i.relative[e[c].type])) p = [me(ge(p), n)];
                    else {
                        if ((n = i.filter[e[c].type].apply(null, e[c].matches))[v]) {
                            for (o = ++c; r > o && !i.relative[e[o].type]; o++);
                            return ve(c > 1 && ge(p), c > 1 && he(e.slice(0, c - 1).concat({ value: " " === e[c - 2].type ? "*" : "" })).replace(M, "$1"), n, o > c && be(e.slice(c, o)), r > o && be((e = e.slice(o))), r > o && he(e));
                        }
                        p.push(n);
                    }
                return ge(p);
            }
            function xe(e, t) {
                var n = t.length > 0,
                    o = e.length > 0,
                    r = function (r, a, l, c, u) {
                        var p,
                            f,
                            h,
                            m = 0,
                            g = "0",
                            y = r && [],
                            v = [],
                            b = s,
                            w = r || (o && i.find.TAG("*", u)),
                            T = (x += null == b ? 1 : Math.random() || 0.1),
                            C = w.length;
                        for (u && (s = a !== d && a); g !== C && null != (p = w[g]); g++) {
                            if (o && p) {
                                for (f = 0; (h = e[f++]); )
                                    if (h(p, a, l)) {
                                        c.push(p);
                                        break;
                                    }
                                u && (x = T);
                            }
                            n && ((p = !h && p) && m--, r && y.push(p));
                        }
                        if (((m += g), n && g !== m)) {
                            for (f = 0; (h = t[f++]); ) h(y, v, a, l);
                            if (r) {
                                if (m > 0) for (; g--; ) y[g] || v[g] || (v[g] = z.call(c));
                                v = ye(v);
                            }
                            D.apply(c, v), u && !r && v.length > 0 && m + t.length > 1 && ne.uniqueSort(c);
                        }
                        return u && ((x = T), (s = b)), y;
                    };
                return n ? oe(r) : r;
            }
            function we(e, t, o, r) {
                var s,
                    l,
                    c,
                    u,
                    d,
                    p = fe(e);
                if (!r && 1 === p.length) {
                    if ((l = p[0] = p[0].slice(0)).length > 2 && "ID" === (c = l[0]).type && n.getById && 9 === t.nodeType && f && i.relative[l[1].type]) {
                        if (!(t = (i.find.ID(c.matches[0].replace(ee, te), t) || [])[0])) return o;
                        e = e.slice(l.shift().value.length);
                    }
                    for (s = G.needsContext.test(e) ? 0 : l.length; s-- && ((c = l[s]), !i.relative[(u = c.type)]); )
                        if ((d = i.find[u]) && (r = d(c.matches[0].replace(ee, te), (Q.test(l[0].type) && de(t.parentNode)) || t))) {
                            if ((l.splice(s, 1), !(e = r.length && he(l)))) return D.apply(o, r), o;
                            break;
                        }
                }
                return a(e, p)(r, t, !f, o, (Q.test(e) && de(t.parentNode)) || t), o;
            }
            return (
                (pe.prototype = i.filters = i.pseudos),
                (i.setFilters = new pe()),
                (a = ne.compile = function (e, t) {
                    var n,
                        i = [],
                        o = [],
                        r = k[e + " "];
                    if (!r) {
                        for (t || (t = fe(e)), n = t.length; n--; ) (r = be(t[n]))[v] ? i.push(r) : o.push(r);
                        r = k(e, xe(o, i));
                    }
                    return r;
                }),
                (n.sortStable = v.split("").sort(N).join("") === v),
                (n.detectDuplicates = !!c),
                u(),
                (n.sortDetached = re(function (e) {
                    return 1 & e.compareDocumentPosition(d.createElement("div"));
                })),
                re(function (e) {
                    return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
                }) ||
                    ae("type|href|height|width", function (e, t, n) {
                        return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }),
                (n.attributes &&
                    re(function (e) {
                        return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    })) ||
                    ae("value", function (e, t, n) {
                        return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue;
                    }),
                re(function (e) {
                    return null == e.getAttribute("disabled");
                }) ||
                    ae(W, function (e, t, n) {
                        var i;
                        return n ? void 0 : !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                    }),
                ne
            );
        })(e);
        (f.find = b), (f.expr = b.selectors), (f.expr[":"] = f.expr.pseudos), (f.unique = b.uniqueSort), (f.text = b.getText), (f.isXMLDoc = b.isXML), (f.contains = b.contains);
        var x = f.expr.match.needsContext,
            w = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
            T = /^.[^:#\[\.,]*$/;
        function C(e, t, n) {
            if (f.isFunction(t))
                return f.grep(e, function (e, i) {
                    return !!t.call(e, i, e) !== n;
                });
            if (t.nodeType)
                return f.grep(e, function (e) {
                    return (e === t) !== n;
                });
            if ("string" == typeof t) {
                if (T.test(t)) return f.filter(t, e, n);
                t = f.filter(t, e);
            }
            return f.grep(e, function (e) {
                return f.inArray(e, t) >= 0 !== n;
            });
        }
        (f.filter = function (e, t, n) {
            var i = t[0];
            return (
                n && (e = ":not(" + e + ")"),
                1 === t.length && 1 === i.nodeType
                    ? f.find.matchesSelector(i, e)
                        ? [i]
                        : []
                    : f.find.matches(
                          e,
                          f.grep(t, function (e) {
                              return 1 === e.nodeType;
                          })
                      )
            );
        }),
            f.fn.extend({
                find: function (e) {
                    var t,
                        n = [],
                        i = this,
                        o = i.length;
                    if ("string" != typeof e)
                        return this.pushStack(
                            f(e).filter(function () {
                                for (t = 0; o > t; t++) if (f.contains(i[t], this)) return !0;
                            })
                        );
                    for (t = 0; o > t; t++) f.find(e, i[t], n);
                    return ((n = this.pushStack(o > 1 ? f.unique(n) : n)).selector = this.selector ? this.selector + " " + e : e), n;
                },
                filter: function (e) {
                    return this.pushStack(C(this, e || [], !1));
                },
                not: function (e) {
                    return this.pushStack(C(this, e || [], !0));
                },
                is: function (e) {
                    return !!C(this, "string" == typeof e && x.test(e) ? f(e) : e || [], !1).length;
                },
            });
        var k,
            N = e.document,
            E = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
        ((f.fn.init = function (e, t) {
            var n, i;
            if (!e) return this;
            if ("string" == typeof e) {
                if (!(n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : E.exec(e)) || (!n[1] && t)) return !t || t.jquery ? (t || k).find(e) : this.constructor(t).find(e);
                if (n[1]) {
                    if (((t = t instanceof f ? t[0] : t), f.merge(this, f.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : N, !0)), w.test(n[1]) && f.isPlainObject(t)))
                        for (n in t) f.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
                    return this;
                }
                if ((i = N.getElementById(n[2])) && i.parentNode) {
                    if (i.id !== n[2]) return k.find(e);
                    (this.length = 1), (this[0] = i);
                }
                return (this.context = N), (this.selector = e), this;
            }
            return e.nodeType
                ? ((this.context = this[0] = e), (this.length = 1), this)
                : f.isFunction(e)
                ? void 0 !== k.ready
                    ? k.ready(e)
                    : e(f)
                : (void 0 !== e.selector && ((this.selector = e.selector), (this.context = e.context)), f.makeArray(e, this));
        }).prototype = f.fn),
            (k = f(N));
        var _ = /^(?:parents|prev(?:Until|All))/,
            S = { children: !0, contents: !0, next: !0, prev: !0 };
        function j(e, t) {
            do {
                e = e[t];
            } while (e && 1 !== e.nodeType);
            return e;
        }
        f.extend({
            dir: function (e, t, n) {
                for (var i = [], o = e[t]; o && 9 !== o.nodeType && (void 0 === n || 1 !== o.nodeType || !f(o).is(n)); ) 1 === o.nodeType && i.push(o), (o = o[t]);
                return i;
            },
            sibling: function (e, t) {
                for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
                return n;
            },
        }),
            f.fn.extend({
                has: function (e) {
                    var t,
                        n = f(e, this),
                        i = n.length;
                    return this.filter(function () {
                        for (t = 0; i > t; t++) if (f.contains(this, n[t])) return !0;
                    });
                },
                closest: function (e, t) {
                    for (var n, i = 0, o = this.length, r = [], a = x.test(e) || "string" != typeof e ? f(e, t || this.context) : 0; o > i; i++)
                        for (n = this[i]; n && n !== t; n = n.parentNode)
                            if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && f.find.matchesSelector(n, e))) {
                                r.push(n);
                                break;
                            }
                    return this.pushStack(r.length > 1 ? f.unique(r) : r);
                },
                index: function (e) {
                    return e ? ("string" == typeof e ? f.inArray(this[0], f(e)) : f.inArray(e.jquery ? e[0] : e, this)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
                },
                add: function (e, t) {
                    return this.pushStack(f.unique(f.merge(this.get(), f(e, t))));
                },
                addBack: function (e) {
                    return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                },
            }),
            f.each(
                {
                    parent: function (e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function (e) {
                        return f.dir(e, "parentNode");
                    },
                    parentsUntil: function (e, t, n) {
                        return f.dir(e, "parentNode", n);
                    },
                    next: function (e) {
                        return j(e, "nextSibling");
                    },
                    prev: function (e) {
                        return j(e, "previousSibling");
                    },
                    nextAll: function (e) {
                        return f.dir(e, "nextSibling");
                    },
                    prevAll: function (e) {
                        return f.dir(e, "previousSibling");
                    },
                    nextUntil: function (e, t, n) {
                        return f.dir(e, "nextSibling", n);
                    },
                    prevUntil: function (e, t, n) {
                        return f.dir(e, "previousSibling", n);
                    },
                    siblings: function (e) {
                        return f.sibling((e.parentNode || {}).firstChild, e);
                    },
                    children: function (e) {
                        return f.sibling(e.firstChild);
                    },
                    contents: function (e) {
                        return f.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : f.merge([], e.childNodes);
                    },
                },
                function (e, t) {
                    f.fn[e] = function (n, i) {
                        var o = f.map(this, t, n);
                        return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = f.filter(i, o)), this.length > 1 && (S[e] || (o = f.unique(o)), _.test(e) && (o = o.reverse())), this.pushStack(o);
                    };
                }
            );
        var z,
            A = /\S+/g,
            D = {};
        function $() {
            N.addEventListener ? (N.removeEventListener("DOMContentLoaded", L, !1), e.removeEventListener("load", L, !1)) : (N.detachEvent("onreadystatechange", L), e.detachEvent("onload", L));
        }
        function L() {
            (N.addEventListener || "load" === event.type || "complete" === N.readyState) && ($(), f.ready());
        }
        (f.Callbacks = function (e) {
            e =
                "string" == typeof e
                    ? D[e] ||
                      (function (e) {
                          var t = (D[e] = {});
                          return (
                              f.each(e.match(A) || [], function (e, n) {
                                  t[n] = !0;
                              }),
                              t
                          );
                      })(e)
                    : f.extend({}, e);
            var t,
                n,
                i,
                o,
                r,
                a,
                s = [],
                l = !e.once && [],
                c = function (d) {
                    for (n = e.memory && d, i = !0, r = a || 0, a = 0, o = s.length, t = !0; s && o > r; r++)
                        if (!1 === s[r].apply(d[0], d[1]) && e.stopOnFalse) {
                            n = !1;
                            break;
                        }
                    (t = !1), s && (l ? l.length && c(l.shift()) : n ? (s = []) : u.disable());
                },
                u = {
                    add: function () {
                        if (s) {
                            var i = s.length;
                            !(function t(n) {
                                f.each(n, function (n, i) {
                                    var o = f.type(i);
                                    "function" === o ? (e.unique && u.has(i)) || s.push(i) : i && i.length && "string" !== o && t(i);
                                });
                            })(arguments),
                                t ? (o = s.length) : n && ((a = i), c(n));
                        }
                        return this;
                    },
                    remove: function () {
                        return (
                            s &&
                                f.each(arguments, function (e, n) {
                                    for (var i; (i = f.inArray(n, s, i)) > -1; ) s.splice(i, 1), t && (o >= i && o--, r >= i && r--);
                                }),
                            this
                        );
                    },
                    has: function (e) {
                        return e ? f.inArray(e, s) > -1 : !(!s || !s.length);
                    },
                    empty: function () {
                        return (s = []), (o = 0), this;
                    },
                    disable: function () {
                        return (s = l = n = void 0), this;
                    },
                    disabled: function () {
                        return !s;
                    },
                    lock: function () {
                        return (l = void 0), n || u.disable(), this;
                    },
                    locked: function () {
                        return !l;
                    },
                    fireWith: function (e, n) {
                        return !s || (i && !l) || ((n = [e, (n = n || []).slice ? n.slice() : n]), t ? l.push(n) : c(n)), this;
                    },
                    fire: function () {
                        return u.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!i;
                    },
                };
            return u;
        }),
            f.extend({
                Deferred: function (e) {
                    var t = [
                            ["resolve", "done", f.Callbacks("once memory"), "resolved"],
                            ["reject", "fail", f.Callbacks("once memory"), "rejected"],
                            ["notify", "progress", f.Callbacks("memory")],
                        ],
                        n = "pending",
                        i = {
                            state: function () {
                                return n;
                            },
                            always: function () {
                                return o.done(arguments).fail(arguments), this;
                            },
                            then: function () {
                                var e = arguments;
                                return f
                                    .Deferred(function (n) {
                                        f.each(t, function (t, r) {
                                            var a = f.isFunction(e[t]) && e[t];
                                            o[r[1]](function () {
                                                var e = a && a.apply(this, arguments);
                                                e && f.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[r[0] + "With"](this === i ? n.promise() : this, a ? [e] : arguments);
                                            });
                                        }),
                                            (e = null);
                                    })
                                    .promise();
                            },
                            promise: function (e) {
                                return null != e ? f.extend(e, i) : i;
                            },
                        },
                        o = {};
                    return (
                        (i.pipe = i.then),
                        f.each(t, function (e, r) {
                            var a = r[2],
                                s = r[3];
                            (i[r[1]] = a.add),
                                s &&
                                    a.add(
                                        function () {
                                            n = s;
                                        },
                                        t[1 ^ e][2].disable,
                                        t[2][2].lock
                                    ),
                                (o[r[0]] = function () {
                                    return o[r[0] + "With"](this === o ? i : this, arguments), this;
                                }),
                                (o[r[0] + "With"] = a.fireWith);
                        }),
                        i.promise(o),
                        e && e.call(o, o),
                        o
                    );
                },
                when: function (e) {
                    var t,
                        n,
                        o,
                        r = 0,
                        a = i.call(arguments),
                        s = a.length,
                        l = 1 !== s || (e && f.isFunction(e.promise)) ? s : 0,
                        c = 1 === l ? e : f.Deferred(),
                        u = function (e, n, o) {
                            return function (r) {
                                (n[e] = this), (o[e] = arguments.length > 1 ? i.call(arguments) : r), o === t ? c.notifyWith(n, o) : --l || c.resolveWith(n, o);
                            };
                        };
                    if (s > 1) for (t = new Array(s), n = new Array(s), o = new Array(s); s > r; r++) a[r] && f.isFunction(a[r].promise) ? a[r].promise().done(u(r, o, a)).fail(c.reject).progress(u(r, n, t)) : --l;
                    return l || c.resolveWith(o, a), c.promise();
                },
            }),
            (f.fn.ready = function (e) {
                return f.ready.promise().done(e), this;
            }),
            f.extend({
                isReady: !1,
                readyWait: 1,
                holdReady: function (e) {
                    e ? f.readyWait++ : f.ready(!0);
                },
                ready: function (e) {
                    if (!0 === e ? !--f.readyWait : !f.isReady) {
                        if (!N.body) return setTimeout(f.ready);
                        (f.isReady = !0), (!0 !== e && --f.readyWait > 0) || (z.resolveWith(N, [f]), f.fn.trigger && f(N).trigger("ready").off("ready"));
                    }
                },
            }),
            (f.ready.promise = function (t) {
                if (!z)
                    if (((z = f.Deferred()), "complete" === N.readyState)) setTimeout(f.ready);
                    else if (N.addEventListener) N.addEventListener("DOMContentLoaded", L, !1), e.addEventListener("load", L, !1);
                    else {
                        N.attachEvent("onreadystatechange", L), e.attachEvent("onload", L);
                        var n = !1;
                        try {
                            n = null == e.frameElement && N.documentElement;
                        } catch (e) {}
                        n &&
                            n.doScroll &&
                            (function e() {
                                if (!f.isReady) {
                                    try {
                                        n.doScroll("left");
                                    } catch (t) {
                                        return setTimeout(e, 50);
                                    }
                                    $(), f.ready();
                                }
                            })();
                    }
                return z.promise(t);
            });
        var W,
            H = "undefined";
        for (W in f(d)) break;
        (d.ownLast = "0" !== W),
            (d.inlineBlockNeedsLayout = !1),
            f(function () {
                var e,
                    t,
                    n = N.getElementsByTagName("body")[0];
                n &&
                    (((e = N.createElement("div")).style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px"),
                    (t = N.createElement("div")),
                    n.appendChild(e).appendChild(t),
                    typeof t.style.zoom !== H && ((t.style.cssText = "border:0;margin:0;width:1px;padding:1px;display:inline;zoom:1"), (d.inlineBlockNeedsLayout = 3 === t.offsetWidth) && (n.style.zoom = 1)),
                    n.removeChild(e),
                    (e = t = null));
            }),
            (function () {
                var e = N.createElement("div");
                if (null == d.deleteExpando) {
                    d.deleteExpando = !0;
                    try {
                        delete e.test;
                    } catch (e) {
                        d.deleteExpando = !1;
                    }
                }
                e = null;
            })(),
            (f.acceptData = function (e) {
                var t = f.noData[(e.nodeName + " ").toLowerCase()],
                    n = +e.nodeType || 1;
                return (1 === n || 9 === n) && (!t || (!0 !== t && e.getAttribute("classid") === t));
            });
        var P = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            q = /([A-Z])/g;
        function F(e, t, n) {
            if (void 0 === n && 1 === e.nodeType) {
                var i = "data-" + t.replace(q, "-$1").toLowerCase();
                if ("string" == typeof (n = e.getAttribute(i))) {
                    try {
                        n = "true" === n || ("false" !== n && ("null" === n ? null : +n + "" === n ? +n : P.test(n) ? f.parseJSON(n) : n));
                    } catch (e) {}
                    f.data(e, t, n);
                } else n = void 0;
            }
            return n;
        }
        function O(e) {
            var t;
            for (t in e) if (("data" !== t || !f.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
            return !0;
        }
        function M(e, t, i, o) {
            if (f.acceptData(e)) {
                var r,
                    a,
                    s = f.expando,
                    l = e.nodeType,
                    c = l ? f.cache : e,
                    u = l ? e[s] : e[s] && s;
                if ((u && c[u] && (o || c[u].data)) || void 0 !== i || "string" != typeof t)
                    return (
                        u || (u = l ? (e[s] = n.pop() || f.guid++) : s),
                        c[u] || (c[u] = l ? {} : { toJSON: f.noop }),
                        ("object" == typeof t || "function" == typeof t) && (o ? (c[u] = f.extend(c[u], t)) : (c[u].data = f.extend(c[u].data, t))),
                        (a = c[u]),
                        o || (a.data || (a.data = {}), (a = a.data)),
                        void 0 !== i && (a[f.camelCase(t)] = i),
                        "string" == typeof t ? null == (r = a[t]) && (r = a[f.camelCase(t)]) : (r = a),
                        r
                    );
            }
        }
        function B(e, t, n) {
            if (f.acceptData(e)) {
                var i,
                    o,
                    r = e.nodeType,
                    a = r ? f.cache : e,
                    s = r ? e[f.expando] : f.expando;
                if (a[s]) {
                    if (t && (i = n ? a[s] : a[s].data)) {
                        f.isArray(t) ? (t = t.concat(f.map(t, f.camelCase))) : t in i ? (t = [t]) : (t = (t = f.camelCase(t)) in i ? [t] : t.split(" ")), (o = t.length);
                        for (; o--; ) delete i[t[o]];
                        if (n ? !O(i) : !f.isEmptyObject(i)) return;
                    }
                    (n || (delete a[s].data, O(a[s]))) && (r ? f.cleanData([e], !0) : d.deleteExpando || a != a.window ? delete a[s] : (a[s] = null));
                }
            }
        }
        f.extend({
            cache: {},
            noData: { "applet ": !0, "embed ": !0, "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" },
            hasData: function (e) {
                return !!(e = e.nodeType ? f.cache[e[f.expando]] : e[f.expando]) && !O(e);
            },
            data: function (e, t, n) {
                return M(e, t, n);
            },
            removeData: function (e, t) {
                return B(e, t);
            },
            _data: function (e, t, n) {
                return M(e, t, n, !0);
            },
            _removeData: function (e, t) {
                return B(e, t, !0);
            },
        }),
            f.fn.extend({
                data: function (e, t) {
                    var n,
                        i,
                        o,
                        r = this[0],
                        a = r && r.attributes;
                    if (void 0 === e) {
                        if (this.length && ((o = f.data(r)), 1 === r.nodeType && !f._data(r, "parsedAttrs"))) {
                            for (n = a.length; n--; ) 0 === (i = a[n].name).indexOf("data-") && F(r, (i = f.camelCase(i.slice(5))), o[i]);
                            f._data(r, "parsedAttrs", !0);
                        }
                        return o;
                    }
                    return "object" == typeof e
                        ? this.each(function () {
                              f.data(this, e);
                          })
                        : arguments.length > 1
                        ? this.each(function () {
                              f.data(this, e, t);
                          })
                        : r
                        ? F(r, e, f.data(r, e))
                        : void 0;
                },
                removeData: function (e) {
                    return this.each(function () {
                        f.removeData(this, e);
                    });
                },
            }),
            f.extend({
                queue: function (e, t, n) {
                    var i;
                    return e ? ((t = (t || "fx") + "queue"), (i = f._data(e, t)), n && (!i || f.isArray(n) ? (i = f._data(e, t, f.makeArray(n))) : i.push(n)), i || []) : void 0;
                },
                dequeue: function (e, t) {
                    t = t || "fx";
                    var n = f.queue(e, t),
                        i = n.length,
                        o = n.shift(),
                        r = f._queueHooks(e, t);
                    "inprogress" === o && ((o = n.shift()), i--),
                        o &&
                            ("fx" === t && n.unshift("inprogress"),
                            delete r.stop,
                            o.call(
                                e,
                                function () {
                                    f.dequeue(e, t);
                                },
                                r
                            )),
                        !i && r && r.empty.fire();
                },
                _queueHooks: function (e, t) {
                    var n = t + "queueHooks";
                    return (
                        f._data(e, n) ||
                        f._data(e, n, {
                            empty: f.Callbacks("once memory").add(function () {
                                f._removeData(e, t + "queue"), f._removeData(e, n);
                            }),
                        })
                    );
                },
            }),
            f.fn.extend({
                queue: function (e, t) {
                    var n = 2;
                    return (
                        "string" != typeof e && ((t = e), (e = "fx"), n--),
                        arguments.length < n
                            ? f.queue(this[0], e)
                            : void 0 === t
                            ? this
                            : this.each(function () {
                                  var n = f.queue(this, e, t);
                                  f._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && f.dequeue(this, e);
                              })
                    );
                },
                dequeue: function (e) {
                    return this.each(function () {
                        f.dequeue(this, e);
                    });
                },
                clearQueue: function (e) {
                    return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                    var n,
                        i = 1,
                        o = f.Deferred(),
                        r = this,
                        a = this.length,
                        s = function () {
                            --i || o.resolveWith(r, [r]);
                        };
                    for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; a--; ) (n = f._data(r[a], e + "queueHooks")) && n.empty && (i++, n.empty.add(s));
                    return s(), o.promise(t);
                },
            });
        var R = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            Z = ["Top", "Right", "Bottom", "Left"],
            I = function (e, t) {
                return (e = t || e), "none" === f.css(e, "display") || !f.contains(e.ownerDocument, e);
            },
            X = (f.access = function (e, t, n, i, o, r, a) {
                var s = 0,
                    l = e.length,
                    c = null == n;
                if ("object" === f.type(n)) for (s in ((o = !0), n)) f.access(e, t, s, n[s], !0, r, a);
                else if (
                    void 0 !== i &&
                    ((o = !0),
                    f.isFunction(i) || (a = !0),
                    c &&
                        (a
                            ? (t.call(e, i), (t = null))
                            : ((c = t),
                              (t = function (e, t, n) {
                                  return c.call(f(e), n);
                              }))),
                    t)
                )
                    for (; l > s; s++) t(e[s], n, a ? i : i.call(e[s], s, t(e[s], n)));
                return o ? e : c ? t.call(e) : l ? t(e[0], n) : r;
            }),
            G = /^(?:checkbox|radio)$/i;
        !(function () {
            var e = N.createDocumentFragment(),
                t = N.createElement("div"),
                n = N.createElement("input");
            if (
                (t.setAttribute("className", "t"),
                (t.innerHTML = "  <link/><table></table><a href='/a'>a</a>"),
                (d.leadingWhitespace = 3 === t.firstChild.nodeType),
                (d.tbody = !t.getElementsByTagName("tbody").length),
                (d.htmlSerialize = !!t.getElementsByTagName("link").length),
                (d.html5Clone = "<:nav></:nav>" !== N.createElement("nav").cloneNode(!0).outerHTML),
                (n.type = "checkbox"),
                (n.checked = !0),
                e.appendChild(n),
                (d.appendChecked = n.checked),
                (t.innerHTML = "<textarea>x</textarea>"),
                (d.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue),
                e.appendChild(t),
                (t.innerHTML = "<input type='radio' checked='checked' name='t'/>"),
                (d.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
                (d.noCloneEvent = !0),
                t.attachEvent &&
                    (t.attachEvent("onclick", function () {
                        d.noCloneEvent = !1;
                    }),
                    t.cloneNode(!0).click()),
                null == d.deleteExpando)
            ) {
                d.deleteExpando = !0;
                try {
                    delete t.test;
                } catch (e) {
                    d.deleteExpando = !1;
                }
            }
            e = t = n = null;
        })(),
            (function () {
                var t,
                    n,
                    i = N.createElement("div");
                for (t in { submit: !0, change: !0, focusin: !0 }) (n = "on" + t), (d[t + "Bubbles"] = n in e) || (i.setAttribute(n, "t"), (d[t + "Bubbles"] = !1 === i.attributes[n].expando));
                i = null;
            })();
        var U = /^(?:input|select|textarea)$/i,
            V = /^key/,
            J = /^(?:mouse|contextmenu)|click/,
            Y = /^(?:focusinfocus|focusoutblur)$/,
            Q = /^([^.]*)(?:\.(.+)|)$/;
        function K() {
            return !0;
        }
        function ee() {
            return !1;
        }
        function te() {
            try {
                return N.activeElement;
            } catch (e) {}
        }
        function ne(e) {
            var t = ie.split("|"),
                n = e.createDocumentFragment();
            if (n.createElement) for (; t.length; ) n.createElement(t.pop());
            return n;
        }
        (f.event = {
            global: {},
            add: function (e, t, n, i, o) {
                var r,
                    a,
                    s,
                    l,
                    c,
                    u,
                    d,
                    p,
                    h,
                    m,
                    g,
                    y = f._data(e);
                if (y) {
                    for (
                        n.handler && ((n = (l = n).handler), (o = l.selector)),
                            n.guid || (n.guid = f.guid++),
                            (a = y.events) || (a = y.events = {}),
                            (u = y.handle) ||
                                ((u = y.handle = function (e) {
                                    return typeof f === H || (e && f.event.triggered === e.type) ? void 0 : f.event.dispatch.apply(u.elem, arguments);
                                }).elem = e),
                            s = (t = (t || "").match(A) || [""]).length;
                        s--;

                    )
                        (h = g = (r = Q.exec(t[s]) || [])[1]),
                            (m = (r[2] || "").split(".").sort()),
                            h &&
                                ((c = f.event.special[h] || {}),
                                (h = (o ? c.delegateType : c.bindType) || h),
                                (c = f.event.special[h] || {}),
                                (d = f.extend({ type: h, origType: g, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && f.expr.match.needsContext.test(o), namespace: m.join(".") }, l)),
                                (p = a[h]) || (((p = a[h] = []).delegateCount = 0), (c.setup && !1 !== c.setup.call(e, i, m, u)) || (e.addEventListener ? e.addEventListener(h, u, !1) : e.attachEvent && e.attachEvent("on" + h, u))),
                                c.add && (c.add.call(e, d), d.handler.guid || (d.handler.guid = n.guid)),
                                o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                                (f.event.global[h] = !0));
                    e = null;
                }
            },
            remove: function (e, t, n, i, o) {
                var r,
                    a,
                    s,
                    l,
                    c,
                    u,
                    d,
                    p,
                    h,
                    m,
                    g,
                    y = f.hasData(e) && f._data(e);
                if (y && (u = y.events)) {
                    for (c = (t = (t || "").match(A) || [""]).length; c--; )
                        if (((h = g = (s = Q.exec(t[c]) || [])[1]), (m = (s[2] || "").split(".").sort()), h)) {
                            for (d = f.event.special[h] || {}, p = u[(h = (i ? d.delegateType : d.bindType) || h)] || [], s = s[2] && new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)"), l = r = p.length; r--; )
                                (a = p[r]),
                                    (!o && g !== a.origType) ||
                                        (n && n.guid !== a.guid) ||
                                        (s && !s.test(a.namespace)) ||
                                        (i && i !== a.selector && ("**" !== i || !a.selector)) ||
                                        (p.splice(r, 1), a.selector && p.delegateCount--, d.remove && d.remove.call(e, a));
                            l && !p.length && ((d.teardown && !1 !== d.teardown.call(e, m, y.handle)) || f.removeEvent(e, h, y.handle), delete u[h]);
                        } else for (h in u) f.event.remove(e, h + t[c], n, i, !0);
                    f.isEmptyObject(u) && (delete y.handle, f._removeData(e, "events"));
                }
            },
            trigger: function (t, n, i, o) {
                var r,
                    a,
                    s,
                    l,
                    u,
                    d,
                    p,
                    h = [i || N],
                    m = c.call(t, "type") ? t.type : t,
                    g = c.call(t, "namespace") ? t.namespace.split(".") : [];
                if (
                    ((s = d = i = i || N),
                    3 !== i.nodeType &&
                        8 !== i.nodeType &&
                        !Y.test(m + f.event.triggered) &&
                        (m.indexOf(".") >= 0 && ((g = m.split(".")), (m = g.shift()), g.sort()),
                        (a = m.indexOf(":") < 0 && "on" + m),
                        ((t = t[f.expando] ? t : new f.Event(m, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
                        (t.namespace = g.join(".")),
                        (t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (t.result = void 0),
                        t.target || (t.target = i),
                        (n = null == n ? [t] : f.makeArray(n, [t])),
                        (u = f.event.special[m] || {}),
                        o || !u.trigger || !1 !== u.trigger.apply(i, n)))
                ) {
                    if (!o && !u.noBubble && !f.isWindow(i)) {
                        for (l = u.delegateType || m, Y.test(l + m) || (s = s.parentNode); s; s = s.parentNode) h.push(s), (d = s);
                        d === (i.ownerDocument || N) && h.push(d.defaultView || d.parentWindow || e);
                    }
                    for (p = 0; (s = h[p++]) && !t.isPropagationStopped(); )
                        (t.type = p > 1 ? l : u.bindType || m),
                            (r = (f._data(s, "events") || {})[t.type] && f._data(s, "handle")) && r.apply(s, n),
                            (r = a && s[a]) && r.apply && f.acceptData(s) && ((t.result = r.apply(s, n)), !1 === t.result && t.preventDefault());
                    if (((t.type = m), !o && !t.isDefaultPrevented() && (!u._default || !1 === u._default.apply(h.pop(), n)) && f.acceptData(i) && a && i[m] && !f.isWindow(i))) {
                        (d = i[a]) && (i[a] = null), (f.event.triggered = m);
                        try {
                            i[m]();
                        } catch (e) {}
                        (f.event.triggered = void 0), d && (i[a] = d);
                    }
                    return t.result;
                }
            },
            dispatch: function (e) {
                e = f.event.fix(e);
                var t,
                    n,
                    o,
                    r,
                    a,
                    s = [],
                    l = i.call(arguments),
                    c = (f._data(this, "events") || {})[e.type] || [],
                    u = f.event.special[e.type] || {};
                if (((l[0] = e), (e.delegateTarget = this), !u.preDispatch || !1 !== u.preDispatch.call(this, e))) {
                    for (s = f.event.handlers.call(this, e, c), t = 0; (r = s[t++]) && !e.isPropagationStopped(); )
                        for (e.currentTarget = r.elem, a = 0; (o = r.handlers[a++]) && !e.isImmediatePropagationStopped(); )
                            (!e.namespace_re || e.namespace_re.test(o.namespace)) &&
                                ((e.handleObj = o), (e.data = o.data), void 0 !== (n = ((f.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, l)) && !1 === (e.result = n) && (e.preventDefault(), e.stopPropagation()));
                    return u.postDispatch && u.postDispatch.call(this, e), e.result;
                }
            },
            handlers: function (e, t) {
                var n,
                    i,
                    o,
                    r,
                    a = [],
                    s = t.delegateCount,
                    l = e.target;
                if (s && l.nodeType && (!e.button || "click" !== e.type))
                    for (; l != this; l = l.parentNode || this)
                        if (1 === l.nodeType && (!0 !== l.disabled || "click" !== e.type)) {
                            for (o = [], r = 0; s > r; r++) void 0 === o[(n = (i = t[r]).selector + " ")] && (o[n] = i.needsContext ? f(n, this).index(l) >= 0 : f.find(n, this, null, [l]).length), o[n] && o.push(i);
                            o.length && a.push({ elem: l, handlers: o });
                        }
                return s < t.length && a.push({ elem: this, handlers: t.slice(s) }), a;
            },
            fix: function (e) {
                if (e[f.expando]) return e;
                var t,
                    n,
                    i,
                    o = e.type,
                    r = e,
                    a = this.fixHooks[o];
                for (a || (this.fixHooks[o] = a = J.test(o) ? this.mouseHooks : V.test(o) ? this.keyHooks : {}), i = a.props ? this.props.concat(a.props) : this.props, e = new f.Event(r), t = i.length; t--; ) e[(n = i[t])] = r[n];
                return e.target || (e.target = r.srcElement || N), 3 === e.target.nodeType && (e.target = e.target.parentNode), (e.metaKey = !!e.metaKey), a.filter ? a.filter(e, r) : e;
            },
            props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
            fixHooks: {},
            keyHooks: {
                props: "char charCode key keyCode".split(" "),
                filter: function (e, t) {
                    return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e;
                },
            },
            mouseHooks: {
                props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
                filter: function (e, t) {
                    var n,
                        i,
                        o,
                        r = t.button,
                        a = t.fromElement;
                    return (
                        null == e.pageX &&
                            null != t.clientX &&
                            ((o = (i = e.target.ownerDocument || N).documentElement),
                            (n = i.body),
                            (e.pageX = t.clientX + ((o && o.scrollLeft) || (n && n.scrollLeft) || 0) - ((o && o.clientLeft) || (n && n.clientLeft) || 0)),
                            (e.pageY = t.clientY + ((o && o.scrollTop) || (n && n.scrollTop) || 0) - ((o && o.clientTop) || (n && n.clientTop) || 0))),
                        !e.relatedTarget && a && (e.relatedTarget = a === e.target ? t.toElement : a),
                        e.which || void 0 === r || (e.which = 1 & r ? 1 : 2 & r ? 3 : 4 & r ? 2 : 0),
                        e
                    );
                },
            },
            special: {
                load: { noBubble: !0 },
                focus: {
                    trigger: function () {
                        if (this !== te() && this.focus)
                            try {
                                return this.focus(), !1;
                            } catch (e) {}
                    },
                    delegateType: "focusin",
                },
                blur: {
                    trigger: function () {
                        return this === te() && this.blur ? (this.blur(), !1) : void 0;
                    },
                    delegateType: "focusout",
                },
                click: {
                    trigger: function () {
                        return f.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0;
                    },
                    _default: function (e) {
                        return f.nodeName(e.target, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (e) {
                        void 0 !== e.result && (e.originalEvent.returnValue = e.result);
                    },
                },
            },
            simulate: function (e, t, n, i) {
                var o = f.extend(new f.Event(), n, { type: e, isSimulated: !0, originalEvent: {} });
                i ? f.event.trigger(o, null, t) : f.event.dispatch.call(t, o), o.isDefaultPrevented() && n.preventDefault();
            },
        }),
            (f.removeEvent = N.removeEventListener
                ? function (e, t, n) {
                      e.removeEventListener && e.removeEventListener(t, n, !1);
                  }
                : function (e, t, n) {
                      var i = "on" + t;
                      e.detachEvent && (typeof e[i] === H && (e[i] = null), e.detachEvent(i, n));
                  }),
            (f.Event = function (e, t) {
                return this instanceof f.Event
                    ? (e && e.type
                          ? ((this.originalEvent = e),
                            (this.type = e.type),
                            (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && (!1 === e.returnValue || (e.getPreventDefault && e.getPreventDefault()))) ? K : ee))
                          : (this.type = e),
                      t && f.extend(this, t),
                      (this.timeStamp = (e && e.timeStamp) || f.now()),
                      void (this[f.expando] = !0))
                    : new f.Event(e, t);
            }),
            (f.Event.prototype = {
                isDefaultPrevented: ee,
                isPropagationStopped: ee,
                isImmediatePropagationStopped: ee,
                preventDefault: function () {
                    var e = this.originalEvent;
                    (this.isDefaultPrevented = K), e && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1));
                },
                stopPropagation: function () {
                    var e = this.originalEvent;
                    (this.isPropagationStopped = K), e && (e.stopPropagation && e.stopPropagation(), (e.cancelBubble = !0));
                },
                stopImmediatePropagation: function () {
                    (this.isImmediatePropagationStopped = K), this.stopPropagation();
                },
            }),
            f.each({ mouseenter: "mouseover", mouseleave: "mouseout" }, function (e, t) {
                f.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function (e) {
                        var n,
                            i = e.relatedTarget,
                            o = e.handleObj;
                        return (!i || (i !== this && !f.contains(this, i))) && ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)), n;
                    },
                };
            }),
            d.submitBubbles ||
                (f.event.special.submit = {
                    setup: function () {
                        return (
                            !f.nodeName(this, "form") &&
                            void f.event.add(this, "click._submit keypress._submit", function (e) {
                                var t = e.target,
                                    n = f.nodeName(t, "input") || f.nodeName(t, "button") ? t.form : void 0;
                                n &&
                                    !f._data(n, "submitBubbles") &&
                                    (f.event.add(n, "submit._submit", function (e) {
                                        e._submit_bubble = !0;
                                    }),
                                    f._data(n, "submitBubbles", !0));
                            })
                        );
                    },
                    postDispatch: function (e) {
                        e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && f.event.simulate("submit", this.parentNode, e, !0));
                    },
                    teardown: function () {
                        return !f.nodeName(this, "form") && void f.event.remove(this, "._submit");
                    },
                }),
            d.changeBubbles ||
                (f.event.special.change = {
                    setup: function () {
                        return U.test(this.nodeName)
                            ? (("checkbox" === this.type || "radio" === this.type) &&
                                  (f.event.add(this, "propertychange._change", function (e) {
                                      "checked" === e.originalEvent.propertyName && (this._just_changed = !0);
                                  }),
                                  f.event.add(this, "click._change", function (e) {
                                      this._just_changed && !e.isTrigger && (this._just_changed = !1), f.event.simulate("change", this, e, !0);
                                  })),
                              !1)
                            : void f.event.add(this, "beforeactivate._change", function (e) {
                                  var t = e.target;
                                  U.test(t.nodeName) &&
                                      !f._data(t, "changeBubbles") &&
                                      (f.event.add(t, "change._change", function (e) {
                                          !this.parentNode || e.isSimulated || e.isTrigger || f.event.simulate("change", this.parentNode, e, !0);
                                      }),
                                      f._data(t, "changeBubbles", !0));
                              });
                    },
                    handle: function (e) {
                        var t = e.target;
                        return this !== t || e.isSimulated || e.isTrigger || ("radio" !== t.type && "checkbox" !== t.type) ? e.handleObj.handler.apply(this, arguments) : void 0;
                    },
                    teardown: function () {
                        return f.event.remove(this, "._change"), !U.test(this.nodeName);
                    },
                }),
            d.focusinBubbles ||
                f.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                    var n = function (e) {
                        f.event.simulate(t, e.target, f.event.fix(e), !0);
                    };
                    f.event.special[t] = {
                        setup: function () {
                            var i = this.ownerDocument || this,
                                o = f._data(i, t);
                            o || i.addEventListener(e, n, !0), f._data(i, t, (o || 0) + 1);
                        },
                        teardown: function () {
                            var i = this.ownerDocument || this,
                                o = f._data(i, t) - 1;
                            o ? f._data(i, t, o) : (i.removeEventListener(e, n, !0), f._removeData(i, t));
                        },
                    };
                }),
            f.fn.extend({
                on: function (e, t, n, i, o) {
                    var r, a;
                    if ("object" == typeof e) {
                        for (r in ("string" != typeof t && ((n = n || t), (t = void 0)), e)) this.on(r, t, n, e[r], o);
                        return this;
                    }
                    if ((null == n && null == i ? ((i = t), (n = t = void 0)) : null == i && ("string" == typeof t ? ((i = n), (n = void 0)) : ((i = n), (n = t), (t = void 0))), !1 === i)) i = ee;
                    else if (!i) return this;
                    return (
                        1 === o &&
                            ((a = i),
                            ((i = function (e) {
                                return f().off(e), a.apply(this, arguments);
                            }).guid = a.guid || (a.guid = f.guid++))),
                        this.each(function () {
                            f.event.add(this, e, i, n, t);
                        })
                    );
                },
                one: function (e, t, n, i) {
                    return this.on(e, t, n, i, 1);
                },
                off: function (e, t, n) {
                    var i, o;
                    if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), f(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                    if ("object" == typeof e) {
                        for (o in e) this.off(o, t, e[o]);
                        return this;
                    }
                    return (
                        (!1 === t || "function" == typeof t) && ((n = t), (t = void 0)),
                        !1 === n && (n = ee),
                        this.each(function () {
                            f.event.remove(this, e, n, t);
                        })
                    );
                },
                trigger: function (e, t) {
                    return this.each(function () {
                        f.event.trigger(e, t, this);
                    });
                },
                triggerHandler: function (e, t) {
                    var n = this[0];
                    return n ? f.event.trigger(e, t, n, !0) : void 0;
                },
            });
        var ie = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
            oe = / jQuery\d+="(?:null|\d+)"/g,
            re = new RegExp("<(?:" + ie + ")[\\s/>]", "i"),
            ae = /^\s+/,
            se = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
            le = /<([\w:]+)/,
            ce = /<tbody/i,
            ue = /<|&#?\w+;/,
            de = /<(?:script|style|link)/i,
            pe = /checked\s*(?:[^=]|=\s*.checked.)/i,
            fe = /^$|\/(?:java|ecma)script/i,
            he = /^true\/(.*)/,
            me = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
            ge = {
                option: [1, "<select multiple='multiple'>", "</select>"],
                legend: [1, "<fieldset>", "</fieldset>"],
                area: [1, "<map>", "</map>"],
                param: [1, "<object>", "</object>"],
                thead: [1, "<table>", "</table>"],
                tr: [2, "<table><tbody>", "</tbody></table>"],
                col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
                td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                _default: d.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"],
            },
            ye = ne(N).appendChild(N.createElement("div"));
        function ve(e, t) {
            var n,
                i,
                o = 0,
                r = typeof e.getElementsByTagName !== H ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== H ? e.querySelectorAll(t || "*") : void 0;
            if (!r) for (r = [], n = e.childNodes || e; null != (i = n[o]); o++) !t || f.nodeName(i, t) ? r.push(i) : f.merge(r, ve(i, t));
            return void 0 === t || (t && f.nodeName(e, t)) ? f.merge([e], r) : r;
        }
        function be(e) {
            G.test(e.type) && (e.defaultChecked = e.checked);
        }
        function xe(e, t) {
            return f.nodeName(e, "table") && f.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e;
        }
        function we(e) {
            return (e.type = (null !== f.find.attr(e, "type")) + "/" + e.type), e;
        }
        function Te(e) {
            var t = he.exec(e.type);
            return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
        }
        function Ce(e, t) {
            for (var n, i = 0; null != (n = e[i]); i++) f._data(n, "globalEval", !t || f._data(t[i], "globalEval"));
        }
        function ke(e, t) {
            if (1 === t.nodeType && f.hasData(e)) {
                var n,
                    i,
                    o,
                    r = f._data(e),
                    a = f._data(t, r),
                    s = r.events;
                if (s) for (n in (delete a.handle, (a.events = {}), s)) for (i = 0, o = s[n].length; o > i; i++) f.event.add(t, n, s[n][i]);
                a.data && (a.data = f.extend({}, a.data));
            }
        }
        function Ne(e, t) {
            var n, i, o;
            if (1 === t.nodeType) {
                if (((n = t.nodeName.toLowerCase()), !d.noCloneEvent && t[f.expando])) {
                    for (i in (o = f._data(t)).events) f.removeEvent(t, i, o.handle);
                    t.removeAttribute(f.expando);
                }
                "script" === n && t.text !== e.text
                    ? ((we(t).text = e.text), Te(t))
                    : "object" === n
                    ? (t.parentNode && (t.outerHTML = e.outerHTML), d.html5Clone && e.innerHTML && !f.trim(t.innerHTML) && (t.innerHTML = e.innerHTML))
                    : "input" === n && G.test(e.type)
                    ? ((t.defaultChecked = t.checked = e.checked), t.value !== e.value && (t.value = e.value))
                    : "option" === n
                    ? (t.defaultSelected = t.selected = e.defaultSelected)
                    : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue);
            }
        }
        (ge.optgroup = ge.option),
            (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
            (ge.th = ge.td),
            f.extend({
                clone: function (e, t, n) {
                    var i,
                        o,
                        r,
                        a,
                        s,
                        l = f.contains(e.ownerDocument, e);
                    if (
                        (d.html5Clone || f.isXMLDoc(e) || !re.test("<" + e.nodeName + ">") ? (r = e.cloneNode(!0)) : ((ye.innerHTML = e.outerHTML), ye.removeChild((r = ye.firstChild))),
                        !((d.noCloneEvent && d.noCloneChecked) || (1 !== e.nodeType && 11 !== e.nodeType) || f.isXMLDoc(e)))
                    )
                        for (i = ve(r), s = ve(e), a = 0; null != (o = s[a]); ++a) i[a] && Ne(o, i[a]);
                    if (t)
                        if (n) for (s = s || ve(e), i = i || ve(r), a = 0; null != (o = s[a]); a++) ke(o, i[a]);
                        else ke(e, r);
                    return (i = ve(r, "script")).length > 0 && Ce(i, !l && ve(e, "script")), (i = s = o = null), r;
                },
                buildFragment: function (e, t, n, i) {
                    for (var o, r, a, s, l, c, u, p = e.length, h = ne(t), m = [], g = 0; p > g; g++)
                        if ((r = e[g]) || 0 === r)
                            if ("object" === f.type(r)) f.merge(m, r.nodeType ? [r] : r);
                            else if (ue.test(r)) {
                                for (s = s || h.appendChild(t.createElement("div")), l = (le.exec(r) || ["", ""])[1].toLowerCase(), u = ge[l] || ge._default, s.innerHTML = u[1] + r.replace(se, "<$1></$2>") + u[2], o = u[0]; o--; )
                                    s = s.lastChild;
                                if ((!d.leadingWhitespace && ae.test(r) && m.push(t.createTextNode(ae.exec(r)[0])), !d.tbody))
                                    for (o = (r = "table" !== l || ce.test(r) ? ("<table>" !== u[1] || ce.test(r) ? 0 : s) : s.firstChild) && r.childNodes.length; o--; )
                                        f.nodeName((c = r.childNodes[o]), "tbody") && !c.childNodes.length && r.removeChild(c);
                                for (f.merge(m, s.childNodes), s.textContent = ""; s.firstChild; ) s.removeChild(s.firstChild);
                                s = h.lastChild;
                            } else m.push(t.createTextNode(r));
                    for (s && h.removeChild(s), d.appendChecked || f.grep(ve(m, "input"), be), g = 0; (r = m[g++]); )
                        if ((!i || -1 === f.inArray(r, i)) && ((a = f.contains(r.ownerDocument, r)), (s = ve(h.appendChild(r), "script")), a && Ce(s), n)) for (o = 0; (r = s[o++]); ) fe.test(r.type || "") && n.push(r);
                    return (s = null), h;
                },
                cleanData: function (e, t) {
                    for (var i, o, r, a, s = 0, l = f.expando, c = f.cache, u = d.deleteExpando, p = f.event.special; null != (i = e[s]); s++)
                        if ((t || f.acceptData(i)) && (a = (r = i[l]) && c[r])) {
                            if (a.events) for (o in a.events) p[o] ? f.event.remove(i, o) : f.removeEvent(i, o, a.handle);
                            c[r] && (delete c[r], u ? delete i[l] : typeof i.removeAttribute !== H ? i.removeAttribute(l) : (i[l] = null), n.push(r));
                        }
                },
            }),
            f.fn.extend({
                text: function (e) {
                    return X(
                        this,
                        function (e) {
                            return void 0 === e ? f.text(this) : this.empty().append(((this[0] && this[0].ownerDocument) || N).createTextNode(e));
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                append: function () {
                    return this.domManip(arguments, function (e) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || xe(this, e).appendChild(e);
                    });
                },
                prepend: function () {
                    return this.domManip(arguments, function (e) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var t = xe(this, e);
                            t.insertBefore(e, t.firstChild);
                        }
                    });
                },
                before: function () {
                    return this.domManip(arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this);
                    });
                },
                after: function () {
                    return this.domManip(arguments, function (e) {
                        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                    });
                },
                remove: function (e, t) {
                    for (var n, i = e ? f.filter(e, this) : this, o = 0; null != (n = i[o]); o++)
                        t || 1 !== n.nodeType || f.cleanData(ve(n)), n.parentNode && (t && f.contains(n.ownerDocument, n) && Ce(ve(n, "script")), n.parentNode.removeChild(n));
                    return this;
                },
                empty: function () {
                    for (var e, t = 0; null != (e = this[t]); t++) {
                        for (1 === e.nodeType && f.cleanData(ve(e, !1)); e.firstChild; ) e.removeChild(e.firstChild);
                        e.options && f.nodeName(e, "select") && (e.options.length = 0);
                    }
                    return this;
                },
                clone: function (e, t) {
                    return (
                        (e = null != e && e),
                        (t = null == t ? e : t),
                        this.map(function () {
                            return f.clone(this, e, t);
                        })
                    );
                },
                html: function (e) {
                    return X(
                        this,
                        function (e) {
                            var t = this[0] || {},
                                n = 0,
                                i = this.length;
                            if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(oe, "") : void 0;
                            if (!("string" != typeof e || de.test(e) || (!d.htmlSerialize && re.test(e)) || (!d.leadingWhitespace && ae.test(e)) || ge[(le.exec(e) || ["", ""])[1].toLowerCase()])) {
                                e = e.replace(se, "<$1></$2>");
                                try {
                                    for (; i > n; n++) 1 === (t = this[n] || {}).nodeType && (f.cleanData(ve(t, !1)), (t.innerHTML = e));
                                    t = 0;
                                } catch (e) {}
                            }
                            t && this.empty().append(e);
                        },
                        null,
                        e,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var e = arguments[0];
                    return (
                        this.domManip(arguments, function (t) {
                            (e = this.parentNode), f.cleanData(ve(this)), e && e.replaceChild(t, this);
                        }),
                        e && (e.length || e.nodeType) ? this : this.remove()
                    );
                },
                detach: function (e) {
                    return this.remove(e, !0);
                },
                domManip: function (e, t) {
                    e = o.apply([], e);
                    var n,
                        i,
                        r,
                        a,
                        s,
                        l,
                        c = 0,
                        u = this.length,
                        p = this,
                        h = u - 1,
                        m = e[0],
                        g = f.isFunction(m);
                    if (g || (u > 1 && "string" == typeof m && !d.checkClone && pe.test(m)))
                        return this.each(function (n) {
                            var i = p.eq(n);
                            g && (e[0] = m.call(this, n, i.html())), i.domManip(e, t);
                        });
                    if (u && ((n = (l = f.buildFragment(e, this[0].ownerDocument, !1, this)).firstChild), 1 === l.childNodes.length && (l = n), n)) {
                        for (r = (a = f.map(ve(l, "script"), we)).length; u > c; c++) (i = l), c !== h && ((i = f.clone(i, !0, !0)), r && f.merge(a, ve(i, "script"))), t.call(this[c], i, c);
                        if (r)
                            for (s = a[a.length - 1].ownerDocument, f.map(a, Te), c = 0; r > c; c++)
                                (i = a[c]), fe.test(i.type || "") && !f._data(i, "globalEval") && f.contains(s, i) && (i.src ? f._evalUrl && f._evalUrl(i.src) : f.globalEval((i.text || i.textContent || i.innerHTML || "").replace(me, "")));
                        l = n = null;
                    }
                    return this;
                },
            }),
            f.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
                f.fn[e] = function (e) {
                    for (var n, i = 0, o = [], a = f(e), s = a.length - 1; s >= i; i++) (n = i === s ? this : this.clone(!0)), f(a[i])[t](n), r.apply(o, n.get());
                    return this.pushStack(o);
                };
            });
        var Ee,
            _e = {};
        function Se(t, n) {
            var i = f(n.createElement(t)).appendTo(n.body),
                o = e.getDefaultComputedStyle ? e.getDefaultComputedStyle(i[0]).display : f.css(i[0], "display");
            return i.detach(), o;
        }
        function je(e) {
            var t = N,
                n = _e[e];
            return (
                n ||
                    (("none" !== (n = Se(e, t)) && n) ||
                        ((t = ((Ee = (Ee || f("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement))[0].contentWindow || Ee[0].contentDocument).document).write(), t.close(), (n = Se(e, t)), Ee.detach()),
                    (_e[e] = n)),
                n
            );
        }
        !(function () {
            var e,
                t,
                n = N.createElement("div");
            (n.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
                ((e = n.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5"),
                (d.opacity = /^0.5/.test(e.style.opacity)),
                (d.cssFloat = !!e.style.cssFloat),
                (n.style.backgroundClip = "content-box"),
                (n.cloneNode(!0).style.backgroundClip = ""),
                (d.clearCloneStyle = "content-box" === n.style.backgroundClip),
                (e = n = null),
                (d.shrinkWrapBlocks = function () {
                    var e, n, i;
                    if (null == t) {
                        if (!(e = N.getElementsByTagName("body")[0])) return;
                        "border:0;width:0;height:0;position:absolute;top:0;left:-9999px",
                            (n = N.createElement("div")),
                            (i = N.createElement("div")),
                            e.appendChild(n).appendChild(i),
                            (t = !1),
                            typeof i.style.zoom !== H &&
                                ((i.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0;width:1px;padding:1px;zoom:1"),
                                (i.innerHTML = "<div></div>"),
                                (i.firstChild.style.width = "5px"),
                                (t = 3 !== i.offsetWidth)),
                            e.removeChild(n),
                            (e = n = i = null);
                    }
                    return t;
                });
        })();
        var ze,
            Ae,
            De = /^margin/,
            $e = new RegExp("^(" + R + ")(?!px)[a-z%]+$", "i"),
            Le = /^(top|right|bottom|left)$/;
        function We(e, t) {
            return {
                get: function () {
                    var n = e();
                    if (null != n) return n ? void delete this.get : (this.get = t).apply(this, arguments);
                },
            };
        }
        e.getComputedStyle
            ? ((ze = function (e) {
                  return e.ownerDocument.defaultView.getComputedStyle(e, null);
              }),
              (Ae = function (e, t, n) {
                  var i,
                      o,
                      r,
                      a,
                      s = e.style;
                  return (
                      (a = (n = n || ze(e)) ? n.getPropertyValue(t) || n[t] : void 0),
                      n &&
                          ("" !== a || f.contains(e.ownerDocument, e) || (a = f.style(e, t)),
                          $e.test(a) && De.test(t) && ((i = s.width), (o = s.minWidth), (r = s.maxWidth), (s.minWidth = s.maxWidth = s.width = a), (a = n.width), (s.width = i), (s.minWidth = o), (s.maxWidth = r))),
                      void 0 === a ? a : a + ""
                  );
              }))
            : N.documentElement.currentStyle &&
              ((ze = function (e) {
                  return e.currentStyle;
              }),
              (Ae = function (e, t, n) {
                  var i,
                      o,
                      r,
                      a,
                      s = e.style;
                  return (
                      null == (a = (n = n || ze(e)) ? n[t] : void 0) && s && s[t] && (a = s[t]),
                      $e.test(a) && !Le.test(t) && ((i = s.left), (r = (o = e.runtimeStyle) && o.left) && (o.left = e.currentStyle.left), (s.left = "fontSize" === t ? "1em" : a), (a = s.pixelLeft + "px"), (s.left = i), r && (o.left = r)),
                      void 0 === a ? a : a + "" || "auto"
                  );
              })),
            (function () {
                var t,
                    n,
                    i,
                    o,
                    r,
                    a,
                    s = N.createElement("div"),
                    l = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px";
                function c() {
                    var t,
                        n,
                        s = N.getElementsByTagName("body")[0];
                    s &&
                        ((t = N.createElement("div")),
                        (n = N.createElement("div")),
                        (t.style.cssText = l),
                        s.appendChild(t).appendChild(n),
                        (n.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;display:block;padding:1px;border:1px;width:4px;margin-top:1%;top:1%"),
                        f.swap(s, null != s.style.zoom ? { zoom: 1 } : {}, function () {
                            i = 4 === n.offsetWidth;
                        }),
                        (o = !0),
                        (r = !1),
                        (a = !0),
                        e.getComputedStyle && ((r = "1%" !== (e.getComputedStyle(n, null) || {}).top), (o = "4px" === (e.getComputedStyle(n, null) || { width: "4px" }).width)),
                        s.removeChild(t),
                        (n = s = null));
                }
                (s.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
                    ((t = s.getElementsByTagName("a")[0]).style.cssText = "float:left;opacity:.5"),
                    (d.opacity = /^0.5/.test(t.style.opacity)),
                    (d.cssFloat = !!t.style.cssFloat),
                    (s.style.backgroundClip = "content-box"),
                    (s.cloneNode(!0).style.backgroundClip = ""),
                    (d.clearCloneStyle = "content-box" === s.style.backgroundClip),
                    (t = s = null),
                    f.extend(d, {
                        reliableHiddenOffsets: function () {
                            if (null != n) return n;
                            var e,
                                t,
                                i,
                                o = N.createElement("div"),
                                r = N.getElementsByTagName("body")[0];
                            return r
                                ? (o.setAttribute("className", "t"),
                                  (o.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
                                  ((e = N.createElement("div")).style.cssText = l),
                                  r.appendChild(e).appendChild(o),
                                  (o.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
                                  ((t = o.getElementsByTagName("td"))[0].style.cssText = "padding:0;margin:0;border:0;display:none"),
                                  (i = 0 === t[0].offsetHeight),
                                  (t[0].style.display = ""),
                                  (t[1].style.display = "none"),
                                  (n = i && 0 === t[0].offsetHeight),
                                  r.removeChild(e),
                                  (o = r = null),
                                  n)
                                : void 0;
                        },
                        boxSizing: function () {
                            return null == i && c(), i;
                        },
                        boxSizingReliable: function () {
                            return null == o && c(), o;
                        },
                        pixelPosition: function () {
                            return null == r && c(), r;
                        },
                        reliableMarginRight: function () {
                            var t, n, i, o;
                            if (null == a && e.getComputedStyle) {
                                if (!(t = N.getElementsByTagName("body")[0])) return;
                                (n = N.createElement("div")),
                                    (i = N.createElement("div")),
                                    (n.style.cssText = l),
                                    t.appendChild(n).appendChild(i),
                                    ((o = i.appendChild(N.createElement("div"))).style.cssText = i.style.cssText =
                                        "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;padding:0;margin:0;border:0"),
                                    (o.style.marginRight = o.style.width = "0"),
                                    (i.style.width = "1px"),
                                    (a = !parseFloat((e.getComputedStyle(o, null) || {}).marginRight)),
                                    t.removeChild(n);
                            }
                            return a;
                        },
                    });
            })(),
            (f.swap = function (e, t, n, i) {
                var o,
                    r,
                    a = {};
                for (r in t) (a[r] = e.style[r]), (e.style[r] = t[r]);
                for (r in ((o = n.apply(e, i || [])), t)) e.style[r] = a[r];
                return o;
            });
        var He = /alpha\([^)]*\)/i,
            Pe = /opacity\s*=\s*([^)]*)/,
            qe = /^(none|table(?!-c[ea]).+)/,
            Fe = new RegExp("^(" + R + ")(.*)$", "i"),
            Oe = new RegExp("^([+-])=(" + R + ")", "i"),
            Me = { position: "absolute", visibility: "hidden", display: "block" },
            Be = { letterSpacing: 0, fontWeight: 400 },
            Re = ["Webkit", "O", "Moz", "ms"];
        function Ze(e, t) {
            if (t in e) return t;
            for (var n = t.charAt(0).toUpperCase() + t.slice(1), i = t, o = Re.length; o--; ) if ((t = Re[o] + n) in e) return t;
            return i;
        }
        function Ie(e, t) {
            for (var n, i, o, r = [], a = 0, s = e.length; s > a; a++)
                (i = e[a]).style &&
                    ((r[a] = f._data(i, "olddisplay")),
                    (n = i.style.display),
                    t
                        ? (r[a] || "none" !== n || (i.style.display = ""), "" === i.style.display && I(i) && (r[a] = f._data(i, "olddisplay", je(i.nodeName))))
                        : r[a] || ((o = I(i)), ((n && "none" !== n) || !o) && f._data(i, "olddisplay", o ? n : f.css(i, "display"))));
            for (a = 0; s > a; a++) (i = e[a]).style && ((t && "none" !== i.style.display && "" !== i.style.display) || (i.style.display = t ? r[a] || "" : "none"));
            return e;
        }
        function Xe(e, t, n) {
            var i = Fe.exec(t);
            return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : t;
        }
        function Ge(e, t, n, i, o) {
            for (var r = n === (i ? "border" : "content") ? 4 : "width" === t ? 1 : 0, a = 0; 4 > r; r += 2)
                "margin" === n && (a += f.css(e, n + Z[r], !0, o)),
                    i
                        ? ("content" === n && (a -= f.css(e, "padding" + Z[r], !0, o)), "margin" !== n && (a -= f.css(e, "border" + Z[r] + "Width", !0, o)))
                        : ((a += f.css(e, "padding" + Z[r], !0, o)), "padding" !== n && (a += f.css(e, "border" + Z[r] + "Width", !0, o)));
            return a;
        }
        function Ue(e, t, n) {
            var i = !0,
                o = "width" === t ? e.offsetWidth : e.offsetHeight,
                r = ze(e),
                a = d.boxSizing() && "border-box" === f.css(e, "boxSizing", !1, r);
            if (0 >= o || null == o) {
                if (((0 > (o = Ae(e, t, r)) || null == o) && (o = e.style[t]), $e.test(o))) return o;
                (i = a && (d.boxSizingReliable() || o === e.style[t])), (o = parseFloat(o) || 0);
            }
            return o + Ge(e, t, n || (a ? "border" : "content"), i, r) + "px";
        }
        function Ve(e, t, n, i, o) {
            return new Ve.prototype.init(e, t, n, i, o);
        }
        f.extend({
            cssHooks: {
                opacity: {
                    get: function (e, t) {
                        if (t) {
                            var n = Ae(e, "opacity");
                            return "" === n ? "1" : n;
                        }
                    },
                },
            },
            cssNumber: { columnCount: !0, fillOpacity: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 },
            cssProps: { float: d.cssFloat ? "cssFloat" : "styleFloat" },
            style: function (e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                    var o,
                        r,
                        a,
                        s = f.camelCase(t),
                        l = e.style;
                    if (((t = f.cssProps[s] || (f.cssProps[s] = Ze(l, s))), (a = f.cssHooks[t] || f.cssHooks[s]), void 0 === n)) return a && "get" in a && void 0 !== (o = a.get(e, !1, i)) ? o : l[t];
                    if (
                        ("string" === (r = typeof n) && (o = Oe.exec(n)) && ((n = (o[1] + 1) * o[2] + parseFloat(f.css(e, t))), (r = "number")),
                        null != n && n == n && ("number" !== r || f.cssNumber[s] || (n += "px"), d.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), !(a && "set" in a && void 0 === (n = a.set(e, n, i)))))
                    )
                        try {
                            (l[t] = ""), (l[t] = n);
                        } catch (e) {}
                }
            },
            css: function (e, t, n, i) {
                var o,
                    r,
                    a,
                    s = f.camelCase(t);
                return (
                    (t = f.cssProps[s] || (f.cssProps[s] = Ze(e.style, s))),
                    (a = f.cssHooks[t] || f.cssHooks[s]) && "get" in a && (r = a.get(e, !0, n)),
                    void 0 === r && (r = Ae(e, t, i)),
                    "normal" === r && t in Be && (r = Be[t]),
                    "" === n || n ? ((o = parseFloat(r)), !0 === n || f.isNumeric(o) ? o || 0 : r) : r
                );
            },
        }),
            f.each(["height", "width"], function (e, t) {
                f.cssHooks[t] = {
                    get: function (e, n, i) {
                        return n
                            ? 0 === e.offsetWidth && qe.test(f.css(e, "display"))
                                ? f.swap(e, Me, function () {
                                      return Ue(e, t, i);
                                  })
                                : Ue(e, t, i)
                            : void 0;
                    },
                    set: function (e, n, i) {
                        var o = i && ze(e);
                        return Xe(0, n, i ? Ge(e, t, i, d.boxSizing() && "border-box" === f.css(e, "boxSizing", !1, o), o) : 0);
                    },
                };
            }),
            d.opacity ||
                (f.cssHooks.opacity = {
                    get: function (e, t) {
                        return Pe.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? 0.01 * parseFloat(RegExp.$1) + "" : t ? "1" : "";
                    },
                    set: function (e, t) {
                        var n = e.style,
                            i = e.currentStyle,
                            o = f.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
                            r = (i && i.filter) || n.filter || "";
                        (n.zoom = 1),
                            ((t >= 1 || "" === t) && "" === f.trim(r.replace(He, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || (i && !i.filter))) || (n.filter = He.test(r) ? r.replace(He, o) : r + " " + o);
                    },
                }),
            (f.cssHooks.marginRight = We(d.reliableMarginRight, function (e, t) {
                return t ? f.swap(e, { display: "inline-block" }, Ae, [e, "marginRight"]) : void 0;
            })),
            f.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
                (f.cssHooks[e + t] = {
                    expand: function (n) {
                        for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++) o[e + Z[i] + t] = r[i] || r[i - 2] || r[0];
                        return o;
                    },
                }),
                    De.test(e) || (f.cssHooks[e + t].set = Xe);
            }),
            f.fn.extend({
                css: function (e, t) {
                    return X(
                        this,
                        function (e, t, n) {
                            var i,
                                o,
                                r = {},
                                a = 0;
                            if (f.isArray(t)) {
                                for (i = ze(e), o = t.length; o > a; a++) r[t[a]] = f.css(e, t[a], !1, i);
                                return r;
                            }
                            return void 0 !== n ? f.style(e, t, n) : f.css(e, t);
                        },
                        e,
                        t,
                        arguments.length > 1
                    );
                },
                show: function () {
                    return Ie(this, !0);
                },
                hide: function () {
                    return Ie(this);
                },
                toggle: function (e) {
                    return "boolean" == typeof e
                        ? e
                            ? this.show()
                            : this.hide()
                        : this.each(function () {
                              I(this) ? f(this).show() : f(this).hide();
                          });
                },
            }),
            (f.Tween = Ve),
            (Ve.prototype = {
                constructor: Ve,
                init: function (e, t, n, i, o, r) {
                    (this.elem = e), (this.prop = n), (this.easing = o || "swing"), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = r || (f.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                    var e = Ve.propHooks[this.prop];
                    return e && e.get ? e.get(this) : Ve.propHooks._default.get(this);
                },
                run: function (e) {
                    var t,
                        n = Ve.propHooks[this.prop];
                    return (
                        (this.pos = t = this.options.duration ? f.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e),
                        (this.now = (this.end - this.start) * t + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        n && n.set ? n.set(this) : Ve.propHooks._default.set(this),
                        this
                    );
                },
            }),
            (Ve.prototype.init.prototype = Ve.prototype),
            (Ve.propHooks = {
                _default: {
                    get: function (e) {
                        var t;
                        return null == e.elem[e.prop] || (e.elem.style && null != e.elem.style[e.prop]) ? ((t = f.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0) : e.elem[e.prop];
                    },
                    set: function (e) {
                        f.fx.step[e.prop] ? f.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[f.cssProps[e.prop]] || f.cssHooks[e.prop]) ? f.style(e.elem, e.prop, e.now + e.unit) : (e.elem[e.prop] = e.now);
                    },
                },
            }),
            (Ve.propHooks.scrollTop = Ve.propHooks.scrollLeft = {
                set: function (e) {
                    e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                },
            }),
            (f.easing = {
                linear: function (e) {
                    return e;
                },
                swing: function (e) {
                    return 0.5 - Math.cos(e * Math.PI) / 2;
                },
            }),
            (f.fx = Ve.prototype.init),
            (f.fx.step = {});
        var Je,
            Ye,
            Qe = /^(?:toggle|show|hide)$/,
            Ke = new RegExp("^(?:([+-])=|)(" + R + ")([a-z%]*)$", "i"),
            et = /queueHooks$/,
            tt = [
                function (e, t, n) {
                    var i,
                        o,
                        r,
                        a,
                        s,
                        l,
                        c,
                        u,
                        p = this,
                        h = {},
                        m = e.style,
                        g = e.nodeType && I(e),
                        y = f._data(e, "fxshow");
                    for (i in (n.queue ||
                        (null == (s = f._queueHooks(e, "fx")).unqueued &&
                            ((s.unqueued = 0),
                            (l = s.empty.fire),
                            (s.empty.fire = function () {
                                s.unqueued || l();
                            })),
                        s.unqueued++,
                        p.always(function () {
                            p.always(function () {
                                s.unqueued--, f.queue(e, "fx").length || s.empty.fire();
                            });
                        })),
                    1 === e.nodeType &&
                        ("height" in t || "width" in t) &&
                        ((n.overflow = [m.overflow, m.overflowX, m.overflowY]),
                        (c = f.css(e, "display")),
                        (u = je(e.nodeName)),
                        "none" === c && (c = u),
                        "inline" === c && "none" === f.css(e, "float") && (d.inlineBlockNeedsLayout && "inline" !== u ? (m.zoom = 1) : (m.display = "inline-block"))),
                    n.overflow &&
                        ((m.overflow = "hidden"),
                        d.shrinkWrapBlocks() ||
                            p.always(function () {
                                (m.overflow = n.overflow[0]), (m.overflowX = n.overflow[1]), (m.overflowY = n.overflow[2]);
                            })),
                    t))
                        if (((o = t[i]), Qe.exec(o))) {
                            if ((delete t[i], (r = r || "toggle" === o), o === (g ? "hide" : "show"))) {
                                if ("show" !== o || !y || void 0 === y[i]) continue;
                                g = !0;
                            }
                            h[i] = (y && y[i]) || f.style(e, i);
                        }
                    if (!f.isEmptyObject(h))
                        for (i in (y ? "hidden" in y && (g = y.hidden) : (y = f._data(e, "fxshow", {})),
                        r && (y.hidden = !g),
                        g
                            ? f(e).show()
                            : p.done(function () {
                                  f(e).hide();
                              }),
                        p.done(function () {
                            var t;
                            for (t in (f._removeData(e, "fxshow"), h)) f.style(e, t, h[t]);
                        }),
                        h))
                            (a = rt(g ? y[i] : 0, i, p)), i in y || ((y[i] = a.start), g && ((a.end = a.start), (a.start = "width" === i || "height" === i ? 1 : 0)));
                },
            ],
            nt = {
                "*": [
                    function (e, t) {
                        var n = this.createTween(e, t),
                            i = n.cur(),
                            o = Ke.exec(t),
                            r = (o && o[3]) || (f.cssNumber[e] ? "" : "px"),
                            a = (f.cssNumber[e] || ("px" !== r && +i)) && Ke.exec(f.css(n.elem, e)),
                            s = 1,
                            l = 20;
                        if (a && a[3] !== r) {
                            (r = r || a[3]), (o = o || []), (a = +i || 1);
                            do {
                                (a /= s = s || ".5"), f.style(n.elem, e, a + r);
                            } while (s !== (s = n.cur() / i) && 1 !== s && --l);
                        }
                        return o && ((a = n.start = +a || +i || 0), (n.unit = r), (n.end = o[1] ? a + (o[1] + 1) * o[2] : +o[2])), n;
                    },
                ],
            };
        function it() {
            return (
                setTimeout(function () {
                    Je = void 0;
                }),
                (Je = f.now())
            );
        }
        function ot(e, t) {
            var n,
                i = { height: e },
                o = 0;
            for (t = t ? 1 : 0; 4 > o; o += 2 - t) i["margin" + (n = Z[o])] = i["padding" + n] = e;
            return t && (i.opacity = i.width = e), i;
        }
        function rt(e, t, n) {
            for (var i, o = (nt[t] || []).concat(nt["*"]), r = 0, a = o.length; a > r; r++) if ((i = o[r].call(n, t, e))) return i;
        }
        function at(e, t, n) {
            var i,
                o,
                r = 0,
                a = tt.length,
                s = f.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (o) return !1;
                    for (var t = Je || it(), n = Math.max(0, c.startTime + c.duration - t), i = 1 - (n / c.duration || 0), r = 0, a = c.tweens.length; a > r; r++) c.tweens[r].run(i);
                    return s.notifyWith(e, [c, i, n]), 1 > i && a ? n : (s.resolveWith(e, [c]), !1);
                },
                c = s.promise({
                    elem: e,
                    props: f.extend({}, t),
                    opts: f.extend(!0, { specialEasing: {} }, n),
                    originalProperties: t,
                    originalOptions: n,
                    startTime: Je || it(),
                    duration: n.duration,
                    tweens: [],
                    createTween: function (t, n) {
                        var i = f.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                        return c.tweens.push(i), i;
                    },
                    stop: function (t) {
                        var n = 0,
                            i = t ? c.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; i > n; n++) c.tweens[n].run(1);
                        return t ? s.resolveWith(e, [c, t]) : s.rejectWith(e, [c, t]), this;
                    },
                }),
                u = c.props;
            for (
                (function (e, t) {
                    var n, i, o, r, a;
                    for (n in e)
                        if (((o = t[(i = f.camelCase(n))]), (r = e[n]), f.isArray(r) && ((o = r[1]), (r = e[n] = r[0])), n !== i && ((e[i] = r), delete e[n]), (a = f.cssHooks[i]) && ("expand" in a)))
                            for (n in ((r = a.expand(r)), delete e[i], r)) (n in e) || ((e[n] = r[n]), (t[n] = o));
                        else t[i] = o;
                })(u, c.opts.specialEasing);
                a > r;
                r++
            )
                if ((i = tt[r].call(c, e, u, c.opts))) return i;
            return (
                f.map(u, rt, c),
                f.isFunction(c.opts.start) && c.opts.start.call(e, c),
                f.fx.timer(f.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
                c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always)
            );
        }
        (f.Animation = f.extend(at, {
            tweener: function (e, t) {
                f.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.split(" "));
                for (var n, i = 0, o = e.length; o > i; i++) (n = e[i]), (nt[n] = nt[n] || []), nt[n].unshift(t);
            },
            prefilter: function (e, t) {
                t ? tt.unshift(e) : tt.push(e);
            },
        })),
            (f.speed = function (e, t, n) {
                var i = e && "object" == typeof e ? f.extend({}, e) : { complete: n || (!n && t) || (f.isFunction(e) && e), duration: e, easing: (n && t) || (t && !f.isFunction(t) && t) };
                return (
                    (i.duration = f.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in f.fx.speeds ? f.fx.speeds[i.duration] : f.fx.speeds._default),
                    (null == i.queue || !0 === i.queue) && (i.queue = "fx"),
                    (i.old = i.complete),
                    (i.complete = function () {
                        f.isFunction(i.old) && i.old.call(this), i.queue && f.dequeue(this, i.queue);
                    }),
                    i
                );
            }),
            f.fn.extend({
                fadeTo: function (e, t, n, i) {
                    return this.filter(I).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
                },
                animate: function (e, t, n, i) {
                    var o = f.isEmptyObject(e),
                        r = f.speed(t, n, i),
                        a = function () {
                            var t = at(this, f.extend({}, e), r);
                            (o || f._data(this, "finish")) && t.stop(!0);
                        };
                    return (a.finish = a), o || !1 === r.queue ? this.each(a) : this.queue(r.queue, a);
                },
                stop: function (e, t, n) {
                    var i = function (e) {
                        var t = e.stop;
                        delete e.stop, t(n);
                    };
                    return (
                        "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                        t && !1 !== e && this.queue(e || "fx", []),
                        this.each(function () {
                            var t = !0,
                                o = null != e && e + "queueHooks",
                                r = f.timers,
                                a = f._data(this);
                            if (o) a[o] && a[o].stop && i(a[o]);
                            else for (o in a) a[o] && a[o].stop && et.test(o) && i(a[o]);
                            for (o = r.length; o--; ) r[o].elem !== this || (null != e && r[o].queue !== e) || (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
                            (t || !n) && f.dequeue(this, e);
                        })
                    );
                },
                finish: function (e) {
                    return (
                        !1 !== e && (e = e || "fx"),
                        this.each(function () {
                            var t,
                                n = f._data(this),
                                i = n[e + "queue"],
                                o = n[e + "queueHooks"],
                                r = f.timers,
                                a = i ? i.length : 0;
                            for (n.finish = !0, f.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--; ) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                            for (t = 0; a > t; t++) i[t] && i[t].finish && i[t].finish.call(this);
                            delete n.finish;
                        })
                    );
                },
            }),
            f.each(["toggle", "show", "hide"], function (e, t) {
                var n = f.fn[t];
                f.fn[t] = function (e, i, o) {
                    return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ot(t, !0), e, i, o);
                };
            }),
            f.each({ slideDown: ot("show"), slideUp: ot("hide"), slideToggle: ot("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
                f.fn[e] = function (e, n, i) {
                    return this.animate(t, e, n, i);
                };
            }),
            (f.timers = []),
            (f.fx.tick = function () {
                var e,
                    t = f.timers,
                    n = 0;
                for (Je = f.now(); n < t.length; n++) (e = t[n])() || t[n] !== e || t.splice(n--, 1);
                t.length || f.fx.stop(), (Je = void 0);
            }),
            (f.fx.timer = function (e) {
                f.timers.push(e), e() ? f.fx.start() : f.timers.pop();
            }),
            (f.fx.interval = 13),
            (f.fx.start = function () {
                Ye || (Ye = setInterval(f.fx.tick, f.fx.interval));
            }),
            (f.fx.stop = function () {
                clearInterval(Ye), (Ye = null);
            }),
            (f.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (f.fn.delay = function (e, t) {
                return (
                    (e = (f.fx && f.fx.speeds[e]) || e),
                    (t = t || "fx"),
                    this.queue(t, function (t, n) {
                        var i = setTimeout(t, e);
                        n.stop = function () {
                            clearTimeout(i);
                        };
                    })
                );
            }),
            (function () {
                var e,
                    t,
                    n,
                    i,
                    o = N.createElement("div");
                o.setAttribute("className", "t"),
                    (o.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
                    (e = o.getElementsByTagName("a")[0]),
                    (i = (n = N.createElement("select")).appendChild(N.createElement("option"))),
                    (t = o.getElementsByTagName("input")[0]),
                    (e.style.cssText = "top:1px"),
                    (d.getSetAttribute = "t" !== o.className),
                    (d.style = /top/.test(e.getAttribute("style"))),
                    (d.hrefNormalized = "/a" === e.getAttribute("href")),
                    (d.checkOn = !!t.value),
                    (d.optSelected = i.selected),
                    (d.enctype = !!N.createElement("form").enctype),
                    (n.disabled = !0),
                    (d.optDisabled = !i.disabled),
                    (t = N.createElement("input")).setAttribute("value", ""),
                    (d.input = "" === t.getAttribute("value")),
                    (t.value = "t"),
                    t.setAttribute("type", "radio"),
                    (d.radioValue = "t" === t.value),
                    (e = t = n = i = o = null);
            })();
        var st = /\r/g;
        f.fn.extend({
            val: function (e) {
                var t,
                    n,
                    i,
                    o = this[0];
                return arguments.length
                    ? ((i = f.isFunction(e)),
                      this.each(function (n) {
                          var o;
                          1 === this.nodeType &&
                              (null == (o = i ? e.call(this, n, f(this).val()) : e)
                                  ? (o = "")
                                  : "number" == typeof o
                                  ? (o += "")
                                  : f.isArray(o) &&
                                    (o = f.map(o, function (e) {
                                        return null == e ? "" : e + "";
                                    })),
                              ((t = f.valHooks[this.type] || f.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                      }))
                    : o
                    ? (t = f.valHooks[o.type] || f.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value"))
                        ? n
                        : "string" == typeof (n = o.value)
                        ? n.replace(st, "")
                        : null == n
                        ? ""
                        : n
                    : void 0;
            },
        }),
            f.extend({
                valHooks: {
                    option: {
                        get: function (e) {
                            var t = f.find.attr(e, "value");
                            return null != t ? t : f.text(e);
                        },
                    },
                    select: {
                        get: function (e) {
                            for (var t, n, i = e.options, o = e.selectedIndex, r = "select-one" === e.type || 0 > o, a = r ? null : [], s = r ? o + 1 : i.length, l = 0 > o ? s : r ? o : 0; s > l; l++)
                                if (!((!(n = i[l]).selected && l !== o) || (d.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || (n.parentNode.disabled && f.nodeName(n.parentNode, "optgroup")))) {
                                    if (((t = f(n).val()), r)) return t;
                                    a.push(t);
                                }
                            return a;
                        },
                        set: function (e, t) {
                            for (var n, i, o = e.options, r = f.makeArray(t), a = o.length; a--; )
                                if (((i = o[a]), f.inArray(f.valHooks.option.get(i), r) >= 0))
                                    try {
                                        i.selected = n = !0;
                                    } catch (e) {
                                        i.scrollHeight;
                                    }
                                else i.selected = !1;
                            return n || (e.selectedIndex = -1), o;
                        },
                    },
                },
            }),
            f.each(["radio", "checkbox"], function () {
                (f.valHooks[this] = {
                    set: function (e, t) {
                        return f.isArray(t) ? (e.checked = f.inArray(f(e).val(), t) >= 0) : void 0;
                    },
                }),
                    d.checkOn ||
                        (f.valHooks[this].get = function (e) {
                            return null === e.getAttribute("value") ? "on" : e.value;
                        });
            });
        var lt,
            ct,
            ut = f.expr.attrHandle,
            dt = /^(?:checked|selected)$/i,
            pt = d.getSetAttribute,
            ft = d.input;
        f.fn.extend({
            attr: function (e, t) {
                return X(this, f.attr, e, t, arguments.length > 1);
            },
            removeAttr: function (e) {
                return this.each(function () {
                    f.removeAttr(this, e);
                });
            },
        }),
            f.extend({
                attr: function (e, t, n) {
                    var i,
                        o,
                        r = e.nodeType;
                    if (e && 3 !== r && 8 !== r && 2 !== r)
                        return typeof e.getAttribute === H
                            ? f.prop(e, t, n)
                            : ((1 === r && f.isXMLDoc(e)) || ((t = t.toLowerCase()), (i = f.attrHooks[t] || (f.expr.match.bool.test(t) ? ct : lt))),
                              void 0 === n
                                  ? i && "get" in i && null !== (o = i.get(e, t))
                                      ? o
                                      : null == (o = f.find.attr(e, t))
                                      ? void 0
                                      : o
                                  : null !== n
                                  ? i && "set" in i && void 0 !== (o = i.set(e, n, t))
                                      ? o
                                      : (e.setAttribute(t, n + ""), n)
                                  : void f.removeAttr(e, t));
                },
                removeAttr: function (e, t) {
                    var n,
                        i,
                        o = 0,
                        r = t && t.match(A);
                    if (r && 1 === e.nodeType)
                        for (; (n = r[o++]); ) (i = f.propFix[n] || n), f.expr.match.bool.test(n) ? ((ft && pt) || !dt.test(n) ? (e[i] = !1) : (e[f.camelCase("default-" + n)] = e[i] = !1)) : f.attr(e, n, ""), e.removeAttribute(pt ? n : i);
                },
                attrHooks: {
                    type: {
                        set: function (e, t) {
                            if (!d.radioValue && "radio" === t && f.nodeName(e, "input")) {
                                var n = e.value;
                                return e.setAttribute("type", t), n && (e.value = n), t;
                            }
                        },
                    },
                },
            }),
            (ct = {
                set: function (e, t, n) {
                    return !1 === t ? f.removeAttr(e, n) : (ft && pt) || !dt.test(n) ? e.setAttribute((!pt && f.propFix[n]) || n, n) : (e[f.camelCase("default-" + n)] = e[n] = !0), n;
                },
            }),
            f.each(f.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var n = ut[t] || f.find.attr;
                ut[t] =
                    (ft && pt) || !dt.test(t)
                        ? function (e, t, i) {
                              var o, r;
                              return i || ((r = ut[t]), (ut[t] = o), (o = null != n(e, t, i) ? t.toLowerCase() : null), (ut[t] = r)), o;
                          }
                        : function (e, t, n) {
                              return n ? void 0 : e[f.camelCase("default-" + t)] ? t.toLowerCase() : null;
                          };
            }),
            (ft && pt) ||
                (f.attrHooks.value = {
                    set: function (e, t, n) {
                        return f.nodeName(e, "input") ? void (e.defaultValue = t) : lt && lt.set(e, t, n);
                    },
                }),
            pt ||
                ((lt = {
                    set: function (e, t, n) {
                        var i = e.getAttributeNode(n);
                        return i || e.setAttributeNode((i = e.ownerDocument.createAttribute(n))), (i.value = t += ""), "value" === n || t === e.getAttribute(n) ? t : void 0;
                    },
                }),
                (ut.id = ut.name = ut.coords = function (e, t, n) {
                    var i;
                    return n ? void 0 : (i = e.getAttributeNode(t)) && "" !== i.value ? i.value : null;
                }),
                (f.valHooks.button = {
                    get: function (e, t) {
                        var n = e.getAttributeNode(t);
                        return n && n.specified ? n.value : void 0;
                    },
                    set: lt.set,
                }),
                (f.attrHooks.contenteditable = {
                    set: function (e, t, n) {
                        lt.set(e, "" !== t && t, n);
                    },
                }),
                f.each(["width", "height"], function (e, t) {
                    f.attrHooks[t] = {
                        set: function (e, n) {
                            return "" === n ? (e.setAttribute(t, "auto"), n) : void 0;
                        },
                    };
                })),
            d.style ||
                (f.attrHooks.style = {
                    get: function (e) {
                        return e.style.cssText || void 0;
                    },
                    set: function (e, t) {
                        return (e.style.cssText = t + "");
                    },
                });
        var ht = /^(?:input|select|textarea|button|object)$/i,
            mt = /^(?:a|area)$/i;
        f.fn.extend({
            prop: function (e, t) {
                return X(this, f.prop, e, t, arguments.length > 1);
            },
            removeProp: function (e) {
                return (
                    (e = f.propFix[e] || e),
                    this.each(function () {
                        try {
                            (this[e] = void 0), delete this[e];
                        } catch (e) {}
                    })
                );
            },
        }),
            f.extend({
                propFix: { for: "htmlFor", class: "className" },
                prop: function (e, t, n) {
                    var i,
                        o,
                        r = e.nodeType;
                    if (e && 3 !== r && 8 !== r && 2 !== r)
                        return (
                            (1 !== r || !f.isXMLDoc(e)) && ((t = f.propFix[t] || t), (o = f.propHooks[t])),
                            void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e[t] = n)) : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (e) {
                            var t = f.find.attr(e, "tabindex");
                            return t ? parseInt(t, 10) : ht.test(e.nodeName) || (mt.test(e.nodeName) && e.href) ? 0 : -1;
                        },
                    },
                },
            }),
            d.hrefNormalized ||
                f.each(["href", "src"], function (e, t) {
                    f.propHooks[t] = {
                        get: function (e) {
                            return e.getAttribute(t, 4);
                        },
                    };
                }),
            d.optSelected ||
                (f.propHooks.selected = {
                    get: function (e) {
                        var t = e.parentNode;
                        return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null;
                    },
                }),
            f.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                f.propFix[this.toLowerCase()] = this;
            }),
            d.enctype || (f.propFix.enctype = "encoding");
        var gt = /[\t\r\n\f]/g;
        f.fn.extend({
            addClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    a,
                    s = 0,
                    l = this.length,
                    c = "string" == typeof e && e;
                if (f.isFunction(e))
                    return this.each(function (t) {
                        f(this).addClass(e.call(this, t, this.className));
                    });
                if (c)
                    for (t = (e || "").match(A) || []; l > s; s++)
                        if ((i = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(gt, " ") : " "))) {
                            for (r = 0; (o = t[r++]); ) i.indexOf(" " + o + " ") < 0 && (i += o + " ");
                            (a = f.trim(i)), n.className !== a && (n.className = a);
                        }
                return this;
            },
            removeClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    a,
                    s = 0,
                    l = this.length,
                    c = 0 === arguments.length || ("string" == typeof e && e);
                if (f.isFunction(e))
                    return this.each(function (t) {
                        f(this).removeClass(e.call(this, t, this.className));
                    });
                if (c)
                    for (t = (e || "").match(A) || []; l > s; s++)
                        if ((i = 1 === (n = this[s]).nodeType && (n.className ? (" " + n.className + " ").replace(gt, " ") : ""))) {
                            for (r = 0; (o = t[r++]); ) for (; i.indexOf(" " + o + " ") >= 0; ) i = i.replace(" " + o + " ", " ");
                            (a = e ? f.trim(i) : ""), n.className !== a && (n.className = a);
                        }
                return this;
            },
            toggleClass: function (e, t) {
                var n = typeof e;
                return "boolean" == typeof t && "string" === n
                    ? t
                        ? this.addClass(e)
                        : this.removeClass(e)
                    : this.each(
                          f.isFunction(e)
                              ? function (n) {
                                    f(this).toggleClass(e.call(this, n, this.className, t), t);
                                }
                              : function () {
                                    if ("string" === n) for (var t, i = 0, o = f(this), r = e.match(A) || []; (t = r[i++]); ) o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                                    else (n === H || "boolean" === n) && (this.className && f._data(this, "__className__", this.className), (this.className = this.className || !1 === e ? "" : f._data(this, "__className__") || ""));
                                }
                      );
            },
            hasClass: function (e) {
                for (var t = " " + e + " ", n = 0, i = this.length; i > n; n++) if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(gt, " ").indexOf(t) >= 0) return !0;
                return !1;
            },
        }),
            f.each(
                "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),
                function (e, t) {
                    f.fn[t] = function (e, n) {
                        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                    };
                }
            ),
            f.fn.extend({
                hover: function (e, t) {
                    return this.mouseenter(e).mouseleave(t || e);
                },
                bind: function (e, t, n) {
                    return this.on(e, null, t, n);
                },
                unbind: function (e, t) {
                    return this.off(e, null, t);
                },
                delegate: function (e, t, n, i) {
                    return this.on(t, e, n, i);
                },
                undelegate: function (e, t, n) {
                    return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                },
            });
        var yt = f.now(),
            vt = /\?/,
            bt = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
        (f.parseJSON = function (t) {
            if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
            var n,
                i = null,
                o = f.trim(t + "");
            return o &&
                !f.trim(
                    o.replace(bt, function (e, t, o, r) {
                        return n && t && (i = 0), 0 === i ? e : ((n = o || t), (i += !r - !o), "");
                    })
                )
                ? Function("return " + o)()
                : f.error("Invalid JSON: " + t);
        }),
            (f.parseXML = function (t) {
                var n;
                if (!t || "string" != typeof t) return null;
                try {
                    e.DOMParser ? (n = new DOMParser().parseFromString(t, "text/xml")) : (((n = new ActiveXObject("Microsoft.XMLDOM")).async = "false"), n.loadXML(t));
                } catch (e) {
                    n = void 0;
                }
                return (n && n.documentElement && !n.getElementsByTagName("parsererror").length) || f.error("Invalid XML: " + t), n;
            });
        var xt,
            wt,
            Tt = /#.*$/,
            Ct = /([?&])_=[^&]*/,
            kt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
            Nt = /^(?:GET|HEAD)$/,
            Et = /^\/\//,
            _t = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
            St = {},
            jt = {},
            zt = "*/".concat("*");
        try {
            wt = location.href;
        } catch (e) {
            ((wt = N.createElement("a")).href = ""), (wt = wt.href);
        }
        function At(e) {
            return function (t, n) {
                "string" != typeof t && ((n = t), (t = "*"));
                var i,
                    o = 0,
                    r = t.toLowerCase().match(A) || [];
                if (f.isFunction(n)) for (; (i = r[o++]); ) "+" === i.charAt(0) ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
            };
        }
        function Dt(e, t, n, i) {
            var o = {},
                r = e === jt;
            function a(s) {
                var l;
                return (
                    (o[s] = !0),
                    f.each(e[s] || [], function (e, s) {
                        var c = s(t, n, i);
                        return "string" != typeof c || r || o[c] ? (r ? !(l = c) : void 0) : (t.dataTypes.unshift(c), a(c), !1);
                    }),
                    l
                );
            }
            return a(t.dataTypes[0]) || (!o["*"] && a("*"));
        }
        function $t(e, t) {
            var n,
                i,
                o = f.ajaxSettings.flatOptions || {};
            for (i in t) void 0 !== t[i] && ((o[i] ? e : n || (n = {}))[i] = t[i]);
            return n && f.extend(!0, e, n), e;
        }
        (xt = _t.exec(wt.toLowerCase()) || []),
            f.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: wt,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xt[1]),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": zt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /xml/, html: /html/, json: /json/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": f.parseJSON, "text xml": f.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                    return t ? $t($t(e, f.ajaxSettings), t) : $t(f.ajaxSettings, e);
                },
                ajaxPrefilter: At(St),
                ajaxTransport: At(jt),
                ajax: function (e, t) {
                    "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                    var n,
                        i,
                        o,
                        r,
                        a,
                        s,
                        l,
                        c,
                        u = f.ajaxSetup({}, t),
                        d = u.context || u,
                        p = u.context && (d.nodeType || d.jquery) ? f(d) : f.event,
                        h = f.Deferred(),
                        m = f.Callbacks("once memory"),
                        g = u.statusCode || {},
                        y = {},
                        v = {},
                        b = 0,
                        x = "canceled",
                        w = {
                            readyState: 0,
                            getResponseHeader: function (e) {
                                var t;
                                if (2 === b) {
                                    if (!c) for (c = {}; (t = kt.exec(r)); ) c[t[1].toLowerCase()] = t[2];
                                    t = c[e.toLowerCase()];
                                }
                                return null == t ? null : t;
                            },
                            getAllResponseHeaders: function () {
                                return 2 === b ? r : null;
                            },
                            setRequestHeader: function (e, t) {
                                var n = e.toLowerCase();
                                return b || ((e = v[n] = v[n] || e), (y[e] = t)), this;
                            },
                            overrideMimeType: function (e) {
                                return b || (u.mimeType = e), this;
                            },
                            statusCode: function (e) {
                                var t;
                                if (e)
                                    if (2 > b) for (t in e) g[t] = [g[t], e[t]];
                                    else w.always(e[w.status]);
                                return this;
                            },
                            abort: function (e) {
                                var t = e || x;
                                return l && l.abort(t), T(0, t), this;
                            },
                        };
                    if (
                        ((h.promise(w).complete = m.add),
                        (w.success = w.done),
                        (w.error = w.fail),
                        (u.url = ((e || u.url || wt) + "").replace(Tt, "").replace(Et, xt[1] + "//")),
                        (u.type = t.method || t.type || u.method || u.type),
                        (u.dataTypes = f
                            .trim(u.dataType || "*")
                            .toLowerCase()
                            .match(A) || [""]),
                        null == u.crossDomain &&
                            ((n = _t.exec(u.url.toLowerCase())), (u.crossDomain = !(!n || (n[1] === xt[1] && n[2] === xt[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (xt[3] || ("http:" === xt[1] ? "80" : "443")))))),
                        u.data && u.processData && "string" != typeof u.data && (u.data = f.param(u.data, u.traditional)),
                        Dt(St, u, t, w),
                        2 === b)
                    )
                        return w;
                    for (i in ((s = u.global) && 0 == f.active++ && f.event.trigger("ajaxStart"),
                    (u.type = u.type.toUpperCase()),
                    (u.hasContent = !Nt.test(u.type)),
                    (o = u.url),
                    u.hasContent || (u.data && ((o = u.url += (vt.test(o) ? "&" : "?") + u.data), delete u.data), !1 === u.cache && (u.url = Ct.test(o) ? o.replace(Ct, "$1_=" + yt++) : o + (vt.test(o) ? "&" : "?") + "_=" + yt++)),
                    u.ifModified && (f.lastModified[o] && w.setRequestHeader("If-Modified-Since", f.lastModified[o]), f.etag[o] && w.setRequestHeader("If-None-Match", f.etag[o])),
                    ((u.data && u.hasContent && !1 !== u.contentType) || t.contentType) && w.setRequestHeader("Content-Type", u.contentType),
                    w.setRequestHeader("Accept", u.dataTypes[0] && u.accepts[u.dataTypes[0]] ? u.accepts[u.dataTypes[0]] + ("*" !== u.dataTypes[0] ? ", " + zt + "; q=0.01" : "") : u.accepts["*"]),
                    u.headers))
                        w.setRequestHeader(i, u.headers[i]);
                    if (u.beforeSend && (!1 === u.beforeSend.call(d, w, u) || 2 === b)) return w.abort();
                    for (i in ((x = "abort"), { success: 1, error: 1, complete: 1 })) w[i](u[i]);
                    if ((l = Dt(jt, u, t, w))) {
                        (w.readyState = 1),
                            s && p.trigger("ajaxSend", [w, u]),
                            u.async &&
                                u.timeout > 0 &&
                                (a = setTimeout(function () {
                                    w.abort("timeout");
                                }, u.timeout));
                        try {
                            (b = 1), l.send(y, T);
                        } catch (e) {
                            if (!(2 > b)) throw e;
                            T(-1, e);
                        }
                    } else T(-1, "No Transport");
                    function T(e, t, n, i) {
                        var c,
                            y,
                            v,
                            x,
                            T,
                            C = t;
                        2 !== b &&
                            ((b = 2),
                            a && clearTimeout(a),
                            (l = void 0),
                            (r = i || ""),
                            (w.readyState = e > 0 ? 4 : 0),
                            (c = (e >= 200 && 300 > e) || 304 === e),
                            n &&
                                (x = (function (e, t, n) {
                                    for (var i, o, r, a, s = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === o && (o = e.mimeType || t.getResponseHeader("Content-Type"));
                                    if (o)
                                        for (a in s)
                                            if (s[a] && s[a].test(o)) {
                                                l.unshift(a);
                                                break;
                                            }
                                    if (l[0] in n) r = l[0];
                                    else {
                                        for (a in n) {
                                            if (!l[0] || e.converters[a + " " + l[0]]) {
                                                r = a;
                                                break;
                                            }
                                            i || (i = a);
                                        }
                                        r = r || i;
                                    }
                                    return r ? (r !== l[0] && l.unshift(r), n[r]) : void 0;
                                })(u, w, n)),
                            (x = (function (e, t, n, i) {
                                var o,
                                    r,
                                    a,
                                    s,
                                    l,
                                    c = {},
                                    u = e.dataTypes.slice();
                                if (u[1]) for (a in e.converters) c[a.toLowerCase()] = e.converters[a];
                                for (r = u.shift(); r; )
                                    if ((e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = r), (r = u.shift())))
                                        if ("*" === r) r = l;
                                        else if ("*" !== l && l !== r) {
                                            if (!(a = c[l + " " + r] || c["* " + r]))
                                                for (o in c)
                                                    if ((s = o.split(" "))[1] === r && (a = c[l + " " + s[0]] || c["* " + s[0]])) {
                                                        !0 === a ? (a = c[o]) : !0 !== c[o] && ((r = s[0]), u.unshift(s[1]));
                                                        break;
                                                    }
                                            if (!0 !== a)
                                                if (a && e.throws) t = a(t);
                                                else
                                                    try {
                                                        t = a(t);
                                                    } catch (e) {
                                                        return { state: "parsererror", error: a ? e : "No conversion from " + l + " to " + r };
                                                    }
                                        }
                                return { state: "success", data: t };
                            })(u, x, w, c)),
                            c
                                ? (u.ifModified && ((T = w.getResponseHeader("Last-Modified")) && (f.lastModified[o] = T), (T = w.getResponseHeader("etag")) && (f.etag[o] = T)),
                                  204 === e || "HEAD" === u.type ? (C = "nocontent") : 304 === e ? (C = "notmodified") : ((C = x.state), (y = x.data), (c = !(v = x.error))))
                                : ((v = C), (e || !C) && ((C = "error"), 0 > e && (e = 0))),
                            (w.status = e),
                            (w.statusText = (t || C) + ""),
                            c ? h.resolveWith(d, [y, C, w]) : h.rejectWith(d, [w, C, v]),
                            w.statusCode(g),
                            (g = void 0),
                            s && p.trigger(c ? "ajaxSuccess" : "ajaxError", [w, u, c ? y : v]),
                            m.fireWith(d, [w, C]),
                            s && (p.trigger("ajaxComplete", [w, u]), --f.active || f.event.trigger("ajaxStop")));
                    }
                    return w;
                },
                getJSON: function (e, t, n) {
                    return f.get(e, t, n, "json");
                },
                getScript: function (e, t) {
                    return f.get(e, void 0, t, "script");
                },
            }),
            f.each(["get", "post"], function (e, t) {
                f[t] = function (e, n, i, o) {
                    return f.isFunction(n) && ((o = o || i), (i = n), (n = void 0)), f.ajax({ url: e, type: t, dataType: o, data: n, success: i });
                };
            }),
            f.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
                f.fn[t] = function (e) {
                    return this.on(t, e);
                };
            }),
            (f._evalUrl = function (e) {
                return f.ajax({ url: e, type: "GET", dataType: "script", async: !1, global: !1, throws: !0 });
            }),
            f.fn.extend({
                wrapAll: function (e) {
                    if (f.isFunction(e))
                        return this.each(function (t) {
                            f(this).wrapAll(e.call(this, t));
                        });
                    if (this[0]) {
                        var t = f(e, this[0].ownerDocument).eq(0).clone(!0);
                        this[0].parentNode && t.insertBefore(this[0]),
                            t
                                .map(function () {
                                    for (var e = this; e.firstChild && 1 === e.firstChild.nodeType; ) e = e.firstChild;
                                    return e;
                                })
                                .append(this);
                    }
                    return this;
                },
                wrapInner: function (e) {
                    return this.each(
                        f.isFunction(e)
                            ? function (t) {
                                  f(this).wrapInner(e.call(this, t));
                              }
                            : function () {
                                  var t = f(this),
                                      n = t.contents();
                                  n.length ? n.wrapAll(e) : t.append(e);
                              }
                    );
                },
                wrap: function (e) {
                    var t = f.isFunction(e);
                    return this.each(function (n) {
                        f(this).wrapAll(t ? e.call(this, n) : e);
                    });
                },
                unwrap: function () {
                    return this.parent()
                        .each(function () {
                            f.nodeName(this, "body") || f(this).replaceWith(this.childNodes);
                        })
                        .end();
                },
            }),
            (f.expr.filters.hidden = function (e) {
                return (e.offsetWidth <= 0 && e.offsetHeight <= 0) || (!d.reliableHiddenOffsets() && "none" === ((e.style && e.style.display) || f.css(e, "display")));
            }),
            (f.expr.filters.visible = function (e) {
                return !f.expr.filters.hidden(e);
            });
        var Lt = /%20/g,
            Wt = /\[\]$/,
            Ht = /\r?\n/g,
            Pt = /^(?:submit|button|image|reset|file)$/i,
            qt = /^(?:input|select|textarea|keygen)/i;
        function Ft(e, t, n, i) {
            var o;
            if (f.isArray(t))
                f.each(t, function (t, o) {
                    n || Wt.test(e) ? i(e, o) : Ft(e + "[" + ("object" == typeof o ? t : "") + "]", o, n, i);
                });
            else if (n || "object" !== f.type(t)) i(e, t);
            else for (o in t) Ft(e + "[" + o + "]", t[o], n, i);
        }
        (f.param = function (e, t) {
            var n,
                i = [],
                o = function (e, t) {
                    (t = f.isFunction(t) ? t() : null == t ? "" : t), (i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t));
                };
            if ((void 0 === t && (t = f.ajaxSettings && f.ajaxSettings.traditional), f.isArray(e) || (e.jquery && !f.isPlainObject(e))))
                f.each(e, function () {
                    o(this.name, this.value);
                });
            else for (n in e) Ft(n, e[n], t, o);
            return i.join("&").replace(Lt, "+");
        }),
            f.fn.extend({
                serialize: function () {
                    return f.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var e = f.prop(this, "elements");
                        return e ? f.makeArray(e) : this;
                    })
                        .filter(function () {
                            var e = this.type;
                            return this.name && !f(this).is(":disabled") && qt.test(this.nodeName) && !Pt.test(e) && (this.checked || !G.test(e));
                        })
                        .map(function (e, t) {
                            var n = f(this).val();
                            return null == n
                                ? null
                                : f.isArray(n)
                                ? f.map(n, function (e) {
                                      return { name: t.name, value: e.replace(Ht, "\r\n") };
                                  })
                                : { name: t.name, value: n.replace(Ht, "\r\n") };
                        })
                        .get();
                },
            }),
            (f.ajaxSettings.xhr =
                void 0 !== e.ActiveXObject
                    ? function () {
                          return (
                              (!this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && Rt()) ||
                              (function () {
                                  try {
                                      return new e.ActiveXObject("Microsoft.XMLHTTP");
                                  } catch (e) {}
                              })()
                          );
                      }
                    : Rt);
        var Ot = 0,
            Mt = {},
            Bt = f.ajaxSettings.xhr();
        function Rt() {
            try {
                return new e.XMLHttpRequest();
            } catch (e) {}
        }
        e.ActiveXObject &&
            f(e).on("unload", function () {
                for (var e in Mt) Mt[e](void 0, !0);
            }),
            (d.cors = !!Bt && "withCredentials" in Bt),
            (Bt = d.ajax = !!Bt) &&
                f.ajaxTransport(function (e) {
                    var t;
                    if (!e.crossDomain || d.cors)
                        return {
                            send: function (n, i) {
                                var o,
                                    r = e.xhr(),
                                    a = ++Ot;
                                if ((r.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (o in e.xhrFields) r[o] = e.xhrFields[o];
                                for (o in (e.mimeType && r.overrideMimeType && r.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest"), n))
                                    void 0 !== n[o] && r.setRequestHeader(o, n[o] + "");
                                r.send((e.hasContent && e.data) || null),
                                    (t = function (n, o) {
                                        var s, l, c;
                                        if (t && (o || 4 === r.readyState))
                                            if ((delete Mt[a], (t = void 0), (r.onreadystatechange = f.noop), o)) 4 !== r.readyState && r.abort();
                                            else {
                                                (c = {}), (s = r.status), "string" == typeof r.responseText && (c.text = r.responseText);
                                                try {
                                                    l = r.statusText;
                                                } catch (e) {
                                                    l = "";
                                                }
                                                s || !e.isLocal || e.crossDomain ? 1223 === s && (s = 204) : (s = c.text ? 200 : 404);
                                            }
                                        c && i(s, l, c, r.getAllResponseHeaders());
                                    }),
                                    e.async ? (4 === r.readyState ? setTimeout(t) : (r.onreadystatechange = Mt[a] = t)) : t();
                            },
                            abort: function () {
                                t && t(void 0, !0);
                            },
                        };
                }),
            f.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /(?:java|ecma)script/ },
                converters: {
                    "text script": function (e) {
                        return f.globalEval(e), e;
                    },
                },
            }),
            f.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1), e.crossDomain && ((e.type = "GET"), (e.global = !1));
            }),
            f.ajaxTransport("script", function (e) {
                if (e.crossDomain) {
                    var t,
                        n = N.head || f("head")[0] || N.documentElement;
                    return {
                        send: function (i, o) {
                            ((t = N.createElement("script")).async = !0),
                                e.scriptCharset && (t.charset = e.scriptCharset),
                                (t.src = e.url),
                                (t.onload = t.onreadystatechange = function (e, n) {
                                    (n || !t.readyState || /loaded|complete/.test(t.readyState)) && ((t.onload = t.onreadystatechange = null), t.parentNode && t.parentNode.removeChild(t), (t = null), n || o(200, "success"));
                                }),
                                n.insertBefore(t, n.firstChild);
                        },
                        abort: function () {
                            t && t.onload(void 0, !0);
                        },
                    };
                }
            });
        var Zt = [],
            It = /(=)\?(?=&|$)|\?\?/;
        f.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var e = Zt.pop() || f.expando + "_" + yt++;
                return (this[e] = !0), e;
            },
        }),
            f.ajaxPrefilter("json jsonp", function (t, n, i) {
                var o,
                    r,
                    a,
                    s = !1 !== t.jsonp && (It.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && It.test(t.data) && "data");
                return s || "jsonp" === t.dataTypes[0]
                    ? ((o = t.jsonpCallback = f.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                      s ? (t[s] = t[s].replace(It, "$1" + o)) : !1 !== t.jsonp && (t.url += (vt.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                      (t.converters["script json"] = function () {
                          return a || f.error(o + " was not called"), a[0];
                      }),
                      (t.dataTypes[0] = "json"),
                      (r = e[o]),
                      (e[o] = function () {
                          a = arguments;
                      }),
                      i.always(function () {
                          (e[o] = r), t[o] && ((t.jsonpCallback = n.jsonpCallback), Zt.push(o)), a && f.isFunction(r) && r(a[0]), (a = r = void 0);
                      }),
                      "script")
                    : void 0;
            }),
            (f.parseHTML = function (e, t, n) {
                if (!e || "string" != typeof e) return null;
                "boolean" == typeof t && ((n = t), (t = !1)), (t = t || N);
                var i = w.exec(e),
                    o = !n && [];
                return i ? [t.createElement(i[1])] : ((i = f.buildFragment([e], t, o)), o && o.length && f(o).remove(), f.merge([], i.childNodes));
            });
        var Xt = f.fn.load;
        (f.fn.load = function (e, t, n) {
            if ("string" != typeof e && Xt) return Xt.apply(this, arguments);
            var i,
                o,
                r,
                a = this,
                s = e.indexOf(" ");
            return (
                s >= 0 && ((i = e.slice(s, e.length)), (e = e.slice(0, s))),
                f.isFunction(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (r = "POST"),
                a.length > 0 &&
                    f
                        .ajax({ url: e, type: r, dataType: "html", data: t })
                        .done(function (e) {
                            (o = arguments), a.html(i ? f("<div>").append(f.parseHTML(e)).find(i) : e);
                        })
                        .complete(
                            n &&
                                function (e, t) {
                                    a.each(n, o || [e.responseText, t, e]);
                                }
                        ),
                this
            );
        }),
            (f.expr.filters.animated = function (e) {
                return f.grep(f.timers, function (t) {
                    return e === t.elem;
                }).length;
            });
        var Gt = e.document.documentElement;
        function Ut(e) {
            return f.isWindow(e) ? e : 9 === e.nodeType && (e.defaultView || e.parentWindow);
        }
        (f.offset = {
            setOffset: function (e, t, n) {
                var i,
                    o,
                    r,
                    a,
                    s,
                    l,
                    c = f.css(e, "position"),
                    u = f(e),
                    d = {};
                "static" === c && (e.style.position = "relative"),
                    (s = u.offset()),
                    (r = f.css(e, "top")),
                    (l = f.css(e, "left")),
                    ("absolute" === c || "fixed" === c) && f.inArray("auto", [r, l]) > -1 ? ((a = (i = u.position()).top), (o = i.left)) : ((a = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                    f.isFunction(t) && (t = t.call(e, n, s)),
                    null != t.top && (d.top = t.top - s.top + a),
                    null != t.left && (d.left = t.left - s.left + o),
                    "using" in t ? t.using.call(e, d) : u.css(d);
            },
        }),
            f.fn.extend({
                offset: function (e) {
                    if (arguments.length)
                        return void 0 === e
                            ? this
                            : this.each(function (t) {
                                  f.offset.setOffset(this, e, t);
                              });
                    var t,
                        n,
                        i = { top: 0, left: 0 },
                        o = this[0],
                        r = o && o.ownerDocument;
                    return r
                        ? ((t = r.documentElement),
                          f.contains(t, o)
                              ? (typeof o.getBoundingClientRect !== H && (i = o.getBoundingClientRect()),
                                (n = Ut(r)),
                                { top: i.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0), left: i.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0) })
                              : i)
                        : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var e,
                            t,
                            n = { top: 0, left: 0 },
                            i = this[0];
                        return (
                            "fixed" === f.css(i, "position")
                                ? (t = i.getBoundingClientRect())
                                : ((e = this.offsetParent()), (t = this.offset()), f.nodeName(e[0], "html") || (n = e.offset()), (n.top += f.css(e[0], "borderTopWidth", !0)), (n.left += f.css(e[0], "borderLeftWidth", !0))),
                            { top: t.top - n.top - f.css(i, "marginTop", !0), left: t.left - n.left - f.css(i, "marginLeft", !0) }
                        );
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var e = this.offsetParent || Gt; e && !f.nodeName(e, "html") && "static" === f.css(e, "position"); ) e = e.offsetParent;
                        return e || Gt;
                    });
                },
            }),
            f.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
                var n = /Y/.test(t);
                f.fn[e] = function (i) {
                    return X(
                        this,
                        function (e, i, o) {
                            var r = Ut(e);
                            return void 0 === o ? (r ? (t in r ? r[t] : r.document.documentElement[i]) : e[i]) : void (r ? r.scrollTo(n ? f(r).scrollLeft() : o, n ? o : f(r).scrollTop()) : (e[i] = o));
                        },
                        e,
                        i,
                        arguments.length,
                        null
                    );
                };
            }),
            f.each(["top", "left"], function (e, t) {
                f.cssHooks[t] = We(d.pixelPosition, function (e, n) {
                    return n ? ((n = Ae(e, t)), $e.test(n) ? f(e).position()[t] + "px" : n) : void 0;
                });
            }),
            f.each({ Height: "height", Width: "width" }, function (e, t) {
                f.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                    f.fn[i] = function (i, o) {
                        var r = arguments.length && (n || "boolean" != typeof i),
                            a = n || (!0 === i || !0 === o ? "margin" : "border");
                        return X(
                            this,
                            function (t, n, i) {
                                var o;
                                return f.isWindow(t)
                                    ? t.document.documentElement["client" + e]
                                    : 9 === t.nodeType
                                    ? ((o = t.documentElement), Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e]))
                                    : void 0 === i
                                    ? f.css(t, n, a)
                                    : f.style(t, n, i, a);
                            },
                            t,
                            r ? i : void 0,
                            r,
                            null
                        );
                    };
                });
            }),
            (f.fn.size = function () {
                return this.length;
            }),
            (f.fn.andSelf = f.fn.addBack),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return f;
                });
        var Vt = e.jQuery,
            Jt = e.$;
        return (
            (f.noConflict = function (t) {
                return e.$ === f && (e.$ = Jt), t && e.jQuery === f && (e.jQuery = Vt), f;
            }),
            typeof t === H && (e.jQuery = e.$ = f),
            f
        );
    });
for (var shop = "", scripts = document.getElementsByTagName("script"), i = 0, l = scripts.length; i < l; i++)
    null != scripts[i].getAttribute("data-shop-id") && ((shop = scripts[i].getAttribute("data-shop-id")), (customerid = scripts[i].getAttribute("data-customer-id")));
function ZooomyDataFun(e, t) {
    $.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: { shop: e, customerid: t },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: function (n) {
            var i = n.custom_css,
                o = n.user_added_css,
                r = n.id,
                a = n.product_id,
                s = (n.product_price, n.product_handle),
                l = n.product_name,
                c = n.product_img,
                u = n.wishlist_page_product_text,
                d = n.wishlist_page_product_text_bg,
                p = n.wishlist_page_product_text_f_color,
                f = n.wishlist_page_add_cart_text,
                h = n.wishlist_page_add_cart_text_f_color,
                m = n.wishlist_page_add_cart_text_bg,
                g = n.remove_from_wishlist,
                y = n.remove_from_wishlist_f_color,
                v = n.remove_from_wishlist_bg,
                b = n.layout,
                x = n.shop_currency,
                w = n.shop_name,
                T = n.sold_out_text,
                C = n.directdelete,
                k = n.cus_email,
                N = n.zemail_e_btn,
                E = n.zemail_textarea,
                _ = n.zemail_s_btn,
                S = n.frnd_name,
                j = n.frnd_email,
                z = n.frnd_name_bg,
                A = n.frnd_name_f_color,
                D = n.variant_name,
                L = n.empty_text,
                W = n.plan,
                H = ((s = n.product_handle), "qyghbced" + t + "azhu607h");
            (f = (f = (f = (f = (f = (f = f.replace("&Oslash;", "ÃƒËœ")).replace("&Aring;", "Ãƒâ€¦")).replace("&AElig;", "Ãƒâ€ ")).replace("&oslash;", "ÃƒÂ¸")).replace("&aring;", "ÃƒÂ¥")).replace("&aElig;", "ÃƒÂ¦")),
                (u = (u = (u = (u = (u = (u = u.replace("&Oslash;", "ÃƒËœ")).replace("&Aring;", "Ãƒâ€¦")).replace("&AElig;", "Ãƒâ€ ")).replace("&oslash;", "ÃƒÂ¸")).replace("&aring;", "ÃƒÂ¥")).replace("&aElig;", "ÃƒÂ¦")),
                (g = (g = (g = (g = (g = (g = g.replace("&Oslash;", "ÃƒËœ")).replace("&Aring;", "Ãƒâ€¦")).replace("&AElig;", "Ãƒâ€ ")).replace("&oslash;", "ÃƒÂ¸")).replace("&aring;", "ÃƒÂ¥")).replace("&aElig;", "ÃƒÂ¦"));
            var P = [];
            if ("" == t)
                if ("yes" == n.w_login) {
                    $("#ZoomyWishlistPage").append("<a href='https://" + w + "/account/login' target='_blank' class='zmsg'>" + n.login_save + "</a>");
                    var q = [],
                        F = [],
                        O = [],
                        M = [],
                        B = [],
                        R = [];
                    if (null == localStorage.getItem("myzooomy__wishlist"));
                    else {
                        var Z = "",
                            I = localStorage.getItem("myzooomy__wishlist");
                        (P = JSON.parse(I)),
                            $.each(P, function (e, t) {
                                q.push(t.product_id), F.push(t.product_handle), M.push(t.proprice), O.push(t.protitle), B.push(t.proimage), R.push(t.vname);
                            });
                    }
                    (r = q), (a = q), (s = F), (l = O), (c = B), (D = R);
                } else $("#ZoomyWishlistPage").append("<a href='https://" + w + "/account/login' target='_blank' class='zmsg'>" + n.login_text + "</a>");
            $('<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css">').appendTo("body"),
                $('<link rel="stylesheet" type="text/css" href="https://zooomyapps.com/wishlist/WishlistStyle.css">').appendTo("body"),
                $("<style>" + i + "</style>").appendTo("body"),
                $("<style>span#opencart a { float: right; position: absolute; top: -64px; right: 50px; }span#opencart { float: right; width: 100%; position: relative; }</style>").appendTo("body"),
                $(
                    "<style>.ZoomyWishlistPagecol li.zbodyaction { width: 42%; }.ZoomyWishlistPagecol li.zbodytitle { width: 31%; }.ZoomyWishlistPagecol li.zbodypimg { width: 20%; }.ZoomyWishlistPagecol li.zbodysno { width: 7%; } .ZoomyWishlistPagecol li.zheadaction { width: 42%; }.ZoomyWishlistPagecol li.zheadtitle { width: 31%; }.ZoomyWishlistPagecol li.zheadpimg { width: 20%; }.ZoomyWishlistPagecol li.zheadsno { width: 5%; }.ZoomyWishlistPagecol a, .rte .ZoomyWishlistPagecol a{border:none; outline:none;}.ZoomyWishlistPagecol button{padding: 10px 20px; margin: 2px 3px;border:none;}#wishlist_page_product_text, #wishlist_page_product_text a{background:" +
                        d +
                        "; color:" +
                        p +
                        "; }</style>"
                ).appendTo("body"),
                $("<style>.zopencartlink{background:" + m + "; color:" + h + ";border: none; padding: 1px 10px; }</style>").appendTo("body"),
                $("<style>.zremovefromwish{background:" + v + "; color:" + y + "; }</style>").appendTo("body"),
                ("false" != k && "" != t) || $("<style>#zooomyemailfbtn{display:none;}</style>").appendTo("body"),
                $("<style>.ZoomyWishlistPagecol li{float:left; width:25%; box-sizing:border:box; padding:10px; }.ZoomyWishlistPagecol{float: left; width: 100%;margin-bottom:10px; border-bottom:1px solid #ededed;}</style>").appendTo("body"),
                (0 != a && "0" != a && null != a && "null" != a) ||
                    ("no" == n.w_login ? "" != t && $("#ZoomyWishlistPage .zmsg").replaceWith("<p class='zmsg'>" + L + "</p>") : $("#ZoomyWishlistPage").append("<p class='zmsg'>" + L + "</p>"),
                    $("<style>.ZoomyWishlistPagecol{display:none;}</style>").appendTo("body")),
                $("#ZoomyWishlistPage").before("<span class='zooomyaddtowishlistmsg'></span>"),
                ("nfree" == W && "free" == W) ||
                    ($("#ZoomyWishlistPage").before(
                        "<span class='zooomybtn' id='zooomyemailfbtn' style='cursor:pointer;border: none;float:left; width:100%;'><a id='emailzwishlist' class='' style='background:" + z + "; color:" + A + ";'>" + N + "</a></span>"
                    ),
                    $("#ZoomyWishlistPage").before(
                        "<div id='zemaildata' style='display:none;'><form><input type='text' id='zemailname'  placeholder='" +
                            S +
                            "' required/><input type='email' id='zemailid'   placeholder='" +
                            j +
                            "'  required/><textarea id='zemailmsg' required> " +
                            E +
                            " </textarea><a id='zsendemail'>" +
                            _ +
                            "</a></form></div>"
                    ),
                    (1 != k && "true" != k) ||
                        $(".zooomybtn").append(
                            '<div class="z_social_share_wishlist"><a class="zooomylink_fa"><i class = "fa fa-link"></i></a><a class="zsocial_icon" href="https://www.facebook.com/sharer/sharer.php?u=https://' +
                                w +
                                "/pages/share-wish-list?" +
                                H +
                                '&t=Wishlist" onclick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Facebook"><i class="fa fa-facebook"></i><a href="https://twitter.com/share?url=https://' +
                                w +
                                "/pages/share-wish-list?" +
                                H +
                                '&text=Share Wishlist" onclick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Twitter"><i class="fa fa-twitter"></i></a><a href="http://pinterest.com/pin/create/button/?url=https://' +
                                w +
                                "/pages/share-wish-list?" +
                                H +
                                "&media=" +
                                c[0] +
                                '" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Pinterest"><i class="fa fa-pinterest"></i></a><a href="whatsapp://send?text=https://' +
                                w +
                                "/pages/share-wish-list?" +
                                H +
                                '" data-action="share/whatsapp/share" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on whatsapp"><i class="fa fa-whatsapp"></i></a><a href="mailto:?subject=' +
                                S +
                                "&body=" +
                                E +
                                ": https://" +
                                w +
                                "/pages/share-wish-list?" +
                                H +
                                '" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Mail"><i class="fa fa-envelope"></i></a></div>'
                        ),
                    $("<style> .z_social_share_wishlist .fa{background:" + z + "; color:" + A + ";border:none;}</style>").appendTo("body"),
                    $("#ZoomyWishlistPage").before(
                        "<textarea id='zooomycopytxtarea'  style='display:none;margin:10px 0;float: left; width: 100%; text-align: center; padding: 10px; height: 58px; min-height: 20px; border: 1px solid #eee; font-size: 18px; color: #888;'>https://" +
                            w +
                            "/pages/share-wish-list?" +
                            H +
                            "</textarea>"
                    )),
                $("<style> #zsendemail{background:" + z + "; color:" + A + ";border:none;}</style>").appendTo("body"),
                "list" == b && $("#ZoomyWishlistPage").addClass("zooomywishlistlistclass"),
                $(
                    "<style>.zooomybtn.removefromwishlist.zremovefromwish{ cursor: pointer; border: none; padding: 0; margin: 0; box-sizing: border-box; line-height: 25px; height: 25px; width: 25px;}.ZoomyWishlistPageGrid span.zooomybtn { cursor:pointer;border: none; margin: 2px; padding: 4px 10px; margin-top: 20px; box-sizing: border-box; }.ZoomyWishlistPageGrid{float: left; width: 31.3%; box-sizing: border-box; position: relative; text-align: center; margin: 10px 1%; border: 1px solid #efefef; padding: 20px;}</style>"
                ).appendTo("body"),
                $(
                    "<style>.ZoomyWishlistPageGrid .removefromwishlist {position: absolute; right: 0px; top:0;border: 0; background: " +
                        v +
                        ";color:" +
                        y +
                        "; padding: 0; margin: 0; line-height: 20px; height: 24px; width: 23px; text-align: center; }</style>"
                ).appendTo("body"),
                $.each(r, function (i, o) {
                    $("#ZoomyWishlistPage").append(
                        "<div class='ZoomyWishlistPageGrid' id='ZoomyWishlistPageGrid-" +
                            a[i] +
                            "'> <li class='zbodypimg'><a target='_blank' href='https://" +
                            n.shop_name +
                            "/products/" +
                            s[i] +
                            "'><img src='" +
                            c[i] +
                            "' width='100'></a></li><li class='zbodytitle'><a href='https://" +
                            n.shop_name +
                            "/products/" +
                            s[i] +
                            "'>" +
                            l[i] +
                            "</a></li><li class='zbodyaction'><span class='zooomybtn'  id='wishlist_page_product_text'><a href='https://" +
                            n.shop_name +
                            "/products/" +
                            s[i] +
                            "'>" +
                            u +
                            "</a></span></li></div>"
                    ),
                        $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodyaction").append(
                            "<button id='" + a[i] + "' class='zbtn zooomybtn addcartbtn zopencartlink' value='" + s[i] + "' data-pro-id='" + a[i] + "'>" + f + "</button>"
                        ),
                        $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodypimg").prepend("<button id='rmvfrmwish" + a[i] + "' class='zooomybtn removefromwishlist zremovefromwish' value='" + a[i] + "'>x</button>"),
                        $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodytitle").after(
                            "<li class='zbodyinfo'><div class='zoptionbox' style='float:left;width:100%;margin:10px 0px;'><select class='zooomyshopvariant' id='zooomyshopvariant-" +
                                a[i] +
                                "'></select></div><div class='zqty'><select id='zqtyn-" +
                                a[i] +
                                "'><option value='1'>1</option><option value='2'>2</option><option value='3'>3</option><option value='4'>4</option><option value='5'>5</option><option value='6'>6</option><option value='7'>7</option><option value='8'>8</option><option value='9'>9</option><option value='10'>10</option></select></div></li>"
                        );
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
                    var r = "https://" + n.shop_name + "/cart";
                    $.ajax({
                        url: "/products/" + s[i] + ".js",
                        dataType: "json",
                        success: function (o) {
                            var s = o.price;
                            if (null == (l = o.variants.available)) var l = o.available;
                            if (
                                (0 == l ? $("button#" + a[i]).text(T) : $("button#" + a[i]).text(f),
                                (s = (s /= 100).toFixed(0)),
                                s=numberWithCommas(s),

                                "jens-gullsmidur.myshopify.com" == w && (s *= 100),
                                "hello-sasha.myshopify.com" == w ? (s += x) : (s = x + s),
                                $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodytitle").after("<span class='zprice' style='float:left; width:100%;'>" + s + "</span>"),
                                $(o.variants).each(function (e, t) {
                                    var n = t.title;
                                    null == t.featured_image ? (vimg = "") : (vimg = t.featured_image.src),
                                        $("#zooomyshopvariant-" + a[i]).append(
                                            "<option id='" + t.id + "'  data-id='" + t.id + "'  value='" + t.title + "' data-image='" + vimg + "' data-price='" + t.price + "'  data-available='" + t.available + "' >" + t.title + "</option>"
                                        ),
                                        "Default Title" == n && $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zoptionbox").hide();
                                    var o = $("#zooomyshopvariant-" + a[i]);
                                    o.find("option:selected").text();
                                    "false" == o.find("option:selected").attr("data-available") ? $("button#" + a[i]).text(T) : $("button#" + a[i]).text(f);
                                }),
                                (D[i] = D[i].trim()),
                                "" != D[i])
                            ) {
                                $("#zooomyshopvariant-" + a[i]).val(D[i]);
                                var c = $("#zooomyshopvariant-" + a[i]),
                                    u = (c.find("option:selected").text(), c.find("option:selected").attr("data-image")),
                                    d = c.find("option:selected").attr("data-price"),
                                    p = c.find("option:selected").attr("data-available");
                                "false" == p ? $("button#" + a[i]).text(T) : $("button#" + a[i]).text(f),
                                    "" != u && $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodypimg img").attr("src", u),
                                    (d = (d /= 100).toFixed(0)),
                                    d=numberWithCommas(d),

                                    "hello-sasha.myshopify.com" == w ? (d += x) : (d = x + d),
                                    null == d || "$NaN" == d || $("#ZoomyWishlistPageGrid-" + a[i] + " .zprice").replaceWith("<span class='zprice'>" + d + "</span>"),
                                    p || $("#ZoomyWishlistPageGrid-" + a[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + p + "</span>");
                            }
                            "" == D[i] && $("#zooomyshopvariant-" + a[i]).val(o.variants[0].title),
                                $("#zooomyshopvariant-" + a[i] + "  option").each(function () {
                                    "Default Title" == this.value && $("#zooomyshopvariant-" + a[i]).val("Default Title");
                                }),
                                $("#ZoomyWishlistPageGrid-" + a[i]).change(function () {
                                    var e = $("#zooomyshopvariant-" + a[i]),
                                        t = (e.find("option:selected").text(), e.find("option:selected").attr("data-image")),
                                        n = e.find("option:selected").attr("data-price"),
                                        o = e.find("option:selected").attr("data-available");
                                    "false" == o ? $("button#" + a[i]).text(T) : $("button#" + a[i]).text(f),
                                                                          (n = (n /= 100).toFixed(0)),
                                    n=numberWithCommas(n),
                                        "hello-sasha.myshopify.com" == w ? (n += x) : (n = x + n),
                                        "" != t && $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodypimg img").attr("src", t),
                                        $("#ZoomyWishlistPageGrid-" + a[i] + " .zprice").replaceWith("<span class='zprice'>" + n + "</span>"),
                                        $("#ZoomyWishlistPageGrid-" + a[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + o + "</span>");
                                }),
                                $("#ZoomyWishlistPageGrid-" + a[i] + " .addcartbtn").click(function () {
                                    var o = $("#zooomyshopvariant-" + a[i]);
                                    "" == o.find("option:selected").text() && alert("Please select value from dropdown");
                                    o.find("option:selected").attr("data-image");
                                    var s = $(this).attr("data-pro-id"),
                                        l = o.find("option:selected").attr("data-id"),
                                        c = $("#zqtyn-" + a[i]),
                                        u = (c.find("option:selected").text(), c.val());
                                    null == l && (l = a[i]),
                                        $.ajax({
                                            type: "POST",
                                            url: "/cart/add.js",
                                            dataType: "json",
                                            data: { quantity: u, id: l },
                                            success: function (o) {
                                                $.getJSON("/cart.js", function (o) {
                                                    if ("true" == C) {
                                                        $(".zooomyaddtowishlistmsg").append('<span id="zooomyitemadded"><a href=' + r + ">" + n.open_cart_text + "</a></span>"),
                                                            $("#zooomyitemadded").each(function () {
                                                                $('[id="' + this.id + '"]:gt(0)').remove();
                                                            });
                                                        $.ajax({
                                                            url: "https://zooomyapps.com/wishlist/RemoveFromWishlist.php",
                                                            data: { shop: e, productid: s, customerid: t, addtocart: "yes" },
                                                            dataType: "jsonp",
                                                            jsonp: "mylinkprocode",
                                                            async: "true",
                                                            success: function (e) {
                                                                (pid = e.productid), $("#ZoomyWishlistPagecol-" + pid).hide("100"), $("#ZoomyWishlistPageGrid-" + pid).hide("100");
                                                            },
                                                        });
                                                    } else $("button#" + a[i]).replaceWith('<button id="' + a[i] + '" class="zooomybtn addcartbtn zopencartlink" value="' + n.product_handle[i] + '"><a href="' + r + '" style="color:' + h + '">' + n.open_cart_text + "</a></button>");
                                                });
                                            },
                                        });
                                });
                        },
                    });
                }),
                $(".removefromwishlist").click(function () {
                    var n = $(this).val();
                    (P = P.filter((e) => e.product_id != n)),
                        $.ajax({
                            url: "https://zooomyapps.com/wishlist/RemoveFromWishlist.php",
                            data: { shop: e, productid: n, customerid: t },
                            dataType: "jsonp",
                            jsonp: "mylinkprocode",
                            async: "true",
                            success: function (e) {
                                (pid = e.productid), $("#ZoomyWishlistPagecol-" + pid).hide("100"), $("#ZoomyWishlistPageGrid-" + pid).hide("100");
                            },
                        }),
                        (Z = JSON.stringify(P)),
                        localStorage.setItem("myzooomy__wishlist", Z);
                }),
                $("#emailzwishlist").click(function () {
                    $("#zemaildata").slideToggle("100");
                }),
                $("#zsendemail").click(function () {
                    var n = $("#zemailid").val(),
                        i = $("#zemailname").val(),
                        o = $("#zemailmsg").val();
                    if (
                        ("" == i && $("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwsubject'>Add Subject.</span>"),
                        "" == n && $("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwemail'>Add Email address.</span>"),
                        "" != n && "" != i)
                    ) {
                        var r = t;
                        $.ajax({
                            url: "https://zooomyapps.com/wishlist/ZooomyEmailList.php?shop=" + e + "&getcusid=" + r + "&zemailid=" + n,
                            data: { shop: e, getcusid: r, zemailid: n, zemailname: i, zemailmsg: o },
                            dataType: "jsonp",
                            jsonp: "jsonDataCode",
                            async: "true",
                            success: function (e) {
                                e.emailed;
                            },
                        }),
                            $("#zemaildata").slideToggle("100"),
                            $("#emailzwishlist").before("<span class='emailsentz'>Email has been sent</span>");
                    }
                }),
                $(".zooomylink_fa").click(function () {
                    $("#zooomycopytxtarea").fadeIn(400),
                        setTimeout(function () {
                            $("#zooomycopytxtarea").fadeOut(400);
                        }, 5e3);
                }),
                $("<style>" + o + "</style>").appendTo("body");
        },
    });
}
ZooomyDataFun(shop, customerid);
